<template>
  <div class="base_color">
    <div id="container">
      <div class="crossBox"><van-icon @click="close" class="cross" name="cross" /></div>
      <div class="clause">
        <div>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-align:center; line-height:150%; widows:0; orphans:0; font-size:16px">
        <span style="font-family:'黑体'; font-weight:bold; font-size:16px">上海浦东发展银行借记卡章程</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:32pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:16px">
        <span style="font-family:'仿宋_GB2312'">&#xa0;</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:center; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'; font-weight:bold">第一章　总则</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">第一条&nbsp;&nbsp;</span><span style="font-family:'宋体'"> </span><span
          style="font-family:'宋体'">为有效地向社会各界提供优质银行卡服务，规范上海浦东发展银行各境内发卡机构（以下简称“发卡机构”）及持有上海浦东发展银行借记卡的客户（以下简称“持卡人”）的合法权益及义务，依据国家相关法律法规监管规定的规定，制定本章程。</span>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">第二条&nbsp;&nbsp;</span><span style="font-family:'宋体'"> </span><span
          style="font-family:'宋体'">上海浦东发展银行借记卡（以下简称借记卡）是由发卡机构面向个人客户公开发行的、符合发卡机构已加入的相关银行卡清算机构（以下简称“银行卡清算机构”）发卡标准的人民币借记卡。</span>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">第三条&nbsp;&nbsp;</span><span style="font-family:'宋体'"> </span><span
          style="font-family:'宋体'">联名卡（借记卡）是指经监管机关批准的，发卡机构与合作机构（联名单位）联合发行的借记卡附属产品。联名卡（借记卡）适用本章程，但另有约定的除外。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'等线'">&#xa0;</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:center; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'; font-weight:bold">第二章</span><span style="font-family:'宋体'; font-weight:bold">
        </span><span style="font-family:'宋体'; font-weight:bold">申卡和销卡</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">第四条&nbsp;&nbsp;</span><span style="font-family:'宋体'"> </span><span
          style="font-family:'宋体'">境内外自然人均可根据需要申请借记卡。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">第五条&nbsp;&nbsp;</span><span style="font-family:'宋体'"> </span><span
          style="font-family:'宋体'">申请借记卡须遵照个人账户实名制相关要求，根据国家法律法规监管规定提供相应的身份证件及发卡机构要求的其他验证信息，保证其向发卡机构提供的所有申请资料均真实、完整、有效、合法。符合非中国税收居民标准的，还应按照国家法律法规监管规定，提供本人税收居民身份相关信息。</span><span
          style="font-family:'宋体'; font-weight:bold">申请人确认自愿遵守本章程与《上海浦东发展银行借记卡服务协议》（以下简称《服务协议》）及其后之修订版本。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">因办理借记卡所需，</span><span
          style="font-family:'宋体'">申请人同意发卡机构可根据法律法规监管规定和申请人授权查询、获取持卡人的信息，并对申请人身份资料等信息进行审核，审核通过后为申请人办理借记卡。</span><span
          style="font-family:'宋体'">申请人知晓并同意如</span><span style="font-family:'宋体'">审核不通过的</span><span
          style="font-family:'宋体'">，</span><span style="font-family:'宋体'">申请资料</span><span
          style="font-family:'宋体'">无需</span><span style="font-family:'宋体'">退还申请人。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">第六条&nbsp;&nbsp;</span><span style="font-family:'宋体'"> </span><span
          style="font-family:'宋体'">基于保障持卡人享有必要的借记卡服务及配合发卡机构履行反洗钱等职责之目的，</span><span
          style="font-family:'宋体'">发卡机构有权根据国家法律法规、监管要求对客户开展必要的尽职调查工作，</span><span style="font-family:'宋体'">如</span><span
          style="font-family:'宋体'">不予配合，或</span><span style="font-family:'宋体'">持卡人提供的</span><span
          style="font-family:'宋体'">身份证明证件、</span><span style="font-family:'宋体'">通讯地址、联系电话、住址、职业等资料或信息发生变</span><span
          style="font-family:'宋体'">化时，应及时通过发卡机构渠道办理信息变更手续，对于未及时完成上述变更手续的，</span><span
          style="font-family:'宋体'">发卡机构有权暂停或终止借记卡的使用和相关服务，由此产生的经济损失和法律责任应由持卡人承担。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; font-size:10.5pt">
        <span style="font-family:'宋体'">第七条&nbsp;&nbsp;</span><span style="font-family:'宋体'"> </span><span
          style="font-family:'宋体'">持卡人需要停止使用借记卡，可向发卡机构申请销卡。销卡前持卡人应还清全部交易款项和有关费用。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'等线'">&#xa0;</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:center; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'; font-weight:bold">第三章　基础功能</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">第八条&nbsp;&nbsp;</span><span style="font-family:'宋体'"> </span><span
          style="font-family:'宋体'">持卡人可以以借记卡为载体开立一个或多个银行账户。备用金账户是借记卡默认开通的人民币</span><span
          style="font-family:'宋体'">银行结算</span><span style="font-family:'宋体'">账户。</span><span
          style="font-family:'宋体'">持卡人使用借记卡进行的交易，如未特别指明，将默认借记</span><span style="font-family:'等线'">/</span><span
          style="font-family:'宋体'">贷记至人民币</span><span style="font-family:'宋体'">银行结算</span><span
          style="font-family:'宋体'">账户。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">第九条&nbsp;&nbsp;</span><span style="font-family:'宋体'"> </span><span
          style="font-family:'宋体'">根据等级不同，借记卡分为普卡、金卡、白金卡和钻石卡，</span><span
          style="font-family:'宋体'">客户可根据申领条件的不同申请对应等级的借记卡。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">第十条&nbsp;&nbsp;</span><span style="font-family:'宋体'"> </span><span
          style="font-family:'宋体'">借记卡</span><span style="font-family:'宋体'">具有</span><span
          style="font-family:'宋体'">存款、取款、银联渠道的POS消费、消费撤销、预授权类交易、查询对账等业务功能。持卡人可根据需要签约办理</span><span
          style="font-family:'宋体'">电子渠道的</span><span
          style="font-family:'宋体'">转账汇款、基金、投资理财、外汇买卖、第三方存管、贵金属、贷款等其他功能</span><span
          style="font-family:'宋体'">。借记卡不具备透支功能。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">第十一条&nbsp;&nbsp;</span><span style="font-family:'宋体'"> </span><span
          style="font-family:'宋体'">根据借记卡介质形态不同，借记卡分为电子卡和实体卡两种形态。对于建立借记卡卡号但未配置实体卡的为电子借记卡；对于建立借记卡卡号且配置了实体卡的为实体借记卡。电子借记卡可通过电子渠道用卡，实体借记卡除电子渠道外还可通过实体卡受理终端使用借记卡相关功能。</span>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'等线'">&#xa0;</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:center; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'; font-weight:bold">第四章　交易及验证</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">第十二条&nbsp;&nbsp;</span><span style="font-family:'宋体'"> </span><span
          style="font-family:'宋体'">持卡人开立借记卡时</span><span style="font-family:'宋体'">可以</span><span
          style="font-family:'宋体'">设定交易密码。持卡人应妥善保管和正确使用</span><span
          style="font-family:'宋体'">手机号码、动态验证码、客户身份信息、数字证书、生物识别</span><span style="font-family:'宋体'">等个人交易验证信息</span><span
          style="font-family:'宋体'">和手机等个人设备终端</span><span style="font-family:'宋体'">，不将密码</span><span
          style="font-family:'宋体'">等</span><span style="font-family:'宋体'">前述</span><span
          style="font-family:'宋体'">个人交易信息</span><span
          style="font-family:'宋体'">告知或泄露给他人。借记卡密码遗失的，持卡人应凭本人有效身份证件及时向发卡机构办理密码重置。持卡人应在技术和商户环境安全的前提下通过移动通讯设备和互联网（</span><span
          style="font-family:'等线'">INTERNET</span><span style="font-family:'宋体'">）等使用借记卡。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'; font-weight:bold">第十三条&nbsp;&nbsp;</span><span style="font-family:'宋体'; font-weight:bold">
        </span><span style="font-family:'宋体'; font-weight:bold">持卡人同意并理解，根据法律法规监管规定以及发卡机构与持卡人的约定，发卡机构凭交易密码和</span><span
          style="font-family:'等线'; font-weight:bold">/</span><span
          style="font-family:'宋体'; font-weight:bold">或其他认证要素（如</span><span
          style="font-family:'宋体'; font-weight:bold">手机号码、</span><span
          style="font-family:'宋体'; font-weight:bold">动态</span><span
          style="font-family:'宋体'; font-weight:bold">验证码</span><span
          style="font-family:'宋体'; font-weight:bold">、客户身份信息、生物识别等）对交易真实性予以核实并提供服务。因密码和</span><span
          style="font-family:'等线'; font-weight:bold">/</span><span
          style="font-family:'宋体'; font-weight:bold">或其他认证要素（包括</span><span
          style="font-family:'等线'; font-weight:bold">U-KEY</span><span
          style="font-family:'宋体'; font-weight:bold">等账户存取工具和安全认证工具）保管、使用不当而发生交易的，仍视同持卡人的本人授权，持</span><span
          style="font-family:'宋体'; font-weight:bold">卡人应承担相关责任与义务。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">凭借记卡磁条、芯片、设备卡、卡号或密码等电子数据办理的各项交易（包括但不限于通过</span><span
          style="font-family:'等线'">POS</span><span
          style="font-family:'宋体'">终端、电话、手机、短信、互联网等方式进行的借记卡交易）所产生的电子信息记录及交易凭证均为该项交易的有效凭据，并作为正式记账凭证。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'等线'">&#xa0;</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:center; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'; font-weight:bold">第五章　收费</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">第十四条&nbsp;&nbsp;</span><span style="font-family:'宋体'"> </span><span
          style="font-family:'宋体'">发卡机构根据国家法律法规监管规定制定借记卡服务收费项目和收费标准。借记卡收费标准以发卡机构通过营业网点或发卡机构网站或官方微信等渠道最新公布的服务价格目录为准。持卡人申请借记卡即视同接受借记卡收费标准，须按发卡机构规定的收费标准和缴费方式缴纳相关费用。若持卡人未按规定缴纳费用，发卡机构有权中止提供相应服务。</span>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'等线'">&#xa0;</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:center; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'; font-weight:bold">第六章　用卡安全</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">第十五条&nbsp;&nbsp;</span><span style="font-family:'宋体'"> </span><span
          style="font-family:'宋体'">借记卡</span><span style="font-family:'宋体'">须按照法律法规监管规定申请和开立，</span><span
          style="font-family:'宋体'">只限持卡人本人使用，</span><span style="font-family:'宋体'">若发生出租、出借、出售、转让（包括</span><span
          style="font-family:'等线'">U-KEY</span><span
          style="font-family:'宋体'">等账户存取工具和安全认证工具）等，或冒领或冒用银行卡等行为，发卡机构有权按照国家法律法规监管要求要求，暂停或终止借记卡的使用及相关服务，并有权依法追究持卡人法律责任</span><span
          style="font-family:'宋体'">。</span><span style="font-family:'宋体'">发卡机构不承担因上述行为引起的损失或责任。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">第十六条&nbsp;&nbsp;</span><span style="font-family:'宋体'"> </span><span
          style="font-family:'宋体'">持卡人不得参与或协助参与洗钱等违反国家法律法规监管规定的交易，发卡机构有权按照国家法律法规</span><span
          style="font-family:'宋体'">或</span><span style="font-family:'宋体'">监管规定，采取主动锁定、</span><span
          style="font-family:'宋体'">降低交易额度、</span><span
          style="font-family:'宋体'">限制非柜面交易、销卡等控制措施，暂停或终止借记卡的使用及相关服务，保留依法追究持卡人法律责任的权利。发卡机构不承担因上述行为引起的损失或责任。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'; font-weight:bold">第十七条&nbsp;&nbsp;</span><span style="font-family:'宋体'; font-weight:bold">
        </span><span
          style="font-family:'宋体'; font-weight:bold">对于疑似具有伪卡盗用、卡片敏感信息泄露等较高风险的交易，为防范发生资金损失，持卡人同意发卡机构视情况采取拒绝承兑该笔交易或主动锁定、限制非柜面交易等临时控制措施，并在向持卡人核实后协助予以解除控制。发卡机构不承担因上述行为引起的损失或责任。</span>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'; font-weight:bold">第十八条&nbsp;&nbsp;</span><span style="font-family:'宋体'; font-weight:bold">
        </span><span style="font-family:'宋体'; font-weight:bold">对于</span><span
          style="font-family:'宋体'; font-weight:bold">超过</span><span
          style="font-family:'等线'; font-weight:bold">1</span><span
          style="font-family:'宋体'; font-weight:bold">年及以上</span><span
          style="font-family:'宋体'; font-weight:bold">无任何账务交易的、备用金账户余额和应计未计利息数为零也未开通理财</span><span
          style="font-family:'等线'; font-weight:bold">/</span><span
          style="font-family:'宋体'; font-weight:bold">基金</span><span
          style="font-family:'等线'; font-weight:bold">/</span><span
          style="font-family:'宋体'; font-weight:bold">保险</span><span
          style="font-family:'等线'; font-weight:bold">/</span><span
          style="font-family:'宋体'; font-weight:bold">第三方存管</span><span
          style="font-family:'等线'; font-weight:bold">/</span><span
          style="font-family:'宋体'; font-weight:bold">个人贷款还款等业务</span><span
          style="font-family:'宋体'; font-weight:bold">、</span><span
          style="font-family:'宋体'; font-weight:bold">且未销卡</span><span
          style="font-family:'宋体'; font-weight:bold">的借记卡（</span><span
          style="font-family:'宋体'; font-weight:bold">简称</span><span
          style="font-family:'宋体'; font-weight:bold">“双零卡”），</span><span
          style="font-family:'宋体'; font-weight:bold">为了持卡人账户安全，发卡机构有权通过持卡人在持卡机构预留的方式通知持卡人到发卡机构营业网点重新办理账户身份核实手续。</span><span
          style="font-family:'宋体'; font-weight:bold">如</span><span
          style="font-family:'宋体'; font-weight:bold">持卡人拒不配合的，发卡机构可停止该卡的金融服务并销户。</span><span
          style="font-family:'宋体'; font-weight:bold">发卡机构不承担因上述行为引起的损失或责任。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'; font-weight:bold">第十九条&nbsp;&nbsp;</span><span style="font-family:'宋体'; font-weight:bold">
        </span><span style="font-family:'宋体'; font-weight:bold">根据国家法律法规监管规定，持卡人</span><span
          style="font-family:'宋体'; font-weight:bold">开卡之日起六个月内无交易记录的账户，或持卡人</span><span
          style="font-family:'宋体'; font-weight:bold">连续三年以上（含三年）未发生存现、取现、转账等主动交易，</span><span
          style="font-family:'宋体'; font-weight:bold">且</span><span
          style="font-family:'宋体'; font-weight:bold">无信用卡约定还款、个人贷款还款、理财等签约关系，且账户余额低于</span><span
          style="font-family:'等线'; font-weight:bold">100</span><span
          style="font-family:'宋体'; font-weight:bold">元的借记卡账户，</span><span
          style="font-family:'宋体'; font-weight:bold">发卡机构有权暂停借记卡非柜面业务，待持卡人配合重新核实身份后，予以恢复借记卡功能及业务。</span><span
          style="font-family:'宋体'; font-weight:bold">发卡机构不承担</span><span
          style="font-family:'宋体'; font-weight:bold">因上述行为引起的损失或责任。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'; font-weight:bold">第二十条&nbsp;&nbsp;</span><span style="font-family:'宋体'; font-weight:bold">
        </span><span style="font-family:'宋体'; font-weight:bold">对于不符合监管规定开立的借记卡、违反本人意愿使用的借记卡</span><span
          style="font-family:'宋体'; font-weight:bold">、</span><span
          style="font-family:'宋体'; font-weight:bold">或存在其他</span><span
          style="font-family:'宋体'; font-weight:bold">涉及洗钱</span><span
          style="font-family:'宋体'; font-weight:bold">风险隐患的借记卡</span><span
          style="font-family:'宋体'; font-weight:bold">，发卡机构在</span><span
          style="font-family:'宋体'; font-weight:bold">通过</span><span
          style="font-family:'宋体'; font-weight:bold">公</span><span
          style="font-family:'宋体'; font-weight:bold">告或</span><span
          style="font-family:'宋体'; font-weight:bold">短信等方式</span><span
          style="font-family:'宋体'; font-weight:bold">通知持卡人到发卡机构营业网点重新</span><span
          style="font-family:'宋体'; font-weight:bold">进行尽职调查</span><span
          style="font-family:'宋体'; font-weight:bold">。</span><span
          style="font-family:'宋体'; font-weight:bold">如</span><span
          style="font-family:'宋体'; font-weight:bold">持卡人拒不配合的，发卡机构可停止该卡的金融服务并销户。</span><span
          style="font-family:'宋体'; font-weight:bold">发卡机构不承担因上述行为引起的损失或责任。销卡时将账户余额及应付利息转至本行久悬户。客户可凭本人有效身份证件或借记卡实体卡到本行营业网点领取现金。</span>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'; font-weight:bold">因被他人冒用身份信息开立或代理开立借记卡的，经发卡机构对持卡人有效身份识别、调查后，发卡机构</span><span
          style="font-family:'宋体'; font-weight:bold">终止</span><span
          style="font-family:'宋体'; font-weight:bold">相关借记卡的使用并办理销卡，卡内资金按照国家法律法规监管规定列入久悬专户管理。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'等线'; font-weight:bold">&#xa0;</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:center; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'; font-weight:bold">第七章　附则</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">第二十一条&nbsp;&nbsp;</span><span style="font-family:'宋体'"> </span><span
          style="font-family:'宋体'">本章程由上海浦东发展银行负责制定</span><span style="font-family:'等线'">,</span><span
          style="font-family:'宋体'">并在经报中国银行业监督管理机构备案后生效实施。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span
          style="font-family:'宋体'">上海浦东发展银行有权根据国家法律法规监管规定以及经营需要修改本章程及相关服务（包括收费标准等）内容，在报中国银行保险监督管理机构备案后，在发卡机构的营业网点、网站或监管机关要求的其他渠道进行公告。公告期满后，修改后的章程即对持卡人有约束力，无须另行通知持卡人。在公告期内，持卡人可选择是否继续使用借记卡及相关服务。若持卡人不愿接受公告内容的，可在公告内容正式实施前通过发卡机构渠道办理销卡。公告期满持卡人未办理销卡的，即视为同意接受公告的各项内容。</span>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'">第二十二条&nbsp;&nbsp;</span><span style="font-family:'宋体'"> </span><span
          style="font-family:'宋体'">除双方另有约定外，就</span><span style="font-family:'宋体'">本章程未尽事宜，按照国家法律法规监管规定执行。</span></p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
        <span style="font-family:'宋体'; font-weight:bold; background-color:#ffffff">第二十三条&nbsp;&nbsp;</span><span
          style="font-family:'宋体'; font-weight:bold; background-color:#ffffff"> </span><span
          style="font-family:'宋体'; font-weight:bold; background-color:#ffffff">如客户对本章程或发卡机构提供的借记卡服务有任何疑问、意见或建议，可通过拨打</span><span
          style="font-family:Calibri; font-weight:bold; background-color:#ffffff">955</span><span
          style="font-family:Calibri; font-weight:bold; background-color:#ffffff">28</span><span
          style="font-family:'宋体'; font-weight:bold; background-color:#ffffff">客户服务热线咨询、投诉与反映。</span></p>

          <br/><br/>

          <p
      style="margin-top:0pt; margin-bottom:0pt; text-align:center; line-height:150%; widows:0; orphans:0; font-size:16px">
      <span style="font-family:'黑体'; font-weight:bold; font-size:16px">上海浦东发展银行借记卡服务协议</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:30pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:15pt">
      <span style="font-family:'仿宋_GB2312'">&#xa0;</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">上海浦东发展银行借记卡（以下简称借记卡）是由</span><span
        style="font-family:'宋体'">上海浦东发展银行（以下简称</span><span style="font-family:'宋体'">乙</span><span
        style="font-family:'宋体'">方）</span><span
        style="font-family:'宋体'">面向个人客户公开发行的、符合乙方已加入的相关银行卡清算机构（以下简称“银行卡清算机构”）发卡标准的人民币借记卡。借记卡无附属卡。</span><span
        style="font-family:'宋体'">除双方另有约定外，个人客户申领乙方的各类</span><span style="font-family:'宋体'">型</span><span
        style="font-family:'宋体'">借记卡</span><span style="font-family:'宋体'">均受本协议约束。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">申请人（以下简称</span><span style="font-family:'宋体'">甲</span><span
        style="font-family:'宋体'">方）与</span><span style="font-family:'宋体'">乙</span><span
        style="font-family:'宋体'">方</span><span style="font-family:'宋体'">就</span><span
        style="font-family:'宋体'">申领、</span><span style="font-family:'宋体'">使</span><span
        style="font-family:'宋体'">用借记卡</span><span style="font-family:'宋体'">事</span><span
        style="font-family:'宋体'">宜</span><span style="font-family:'宋体'">签</span><span
        style="font-family:'宋体'">订</span><span style="font-family:'宋体'">如</span><span
        style="font-family:'宋体'">下协议：</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">第一条</span><span style="font-family:'宋体'"> </span><span
        style="font-family:'宋体'">甲方知悉、理解并自愿遵守《上海浦东发展银行借记卡章程》（以下简称“章程”）</span><span
        style="font-family:'宋体'">和本协议约定：</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span
        style="font-family:'宋体'; font-weight:bold">当甲方在纸质版的《上海浦东发展银行个人开户申请书》（以下称“开户申请书”）上签名后视为甲方已签署本服务协议；或甲方在电子渠道勾选并</span><span
        style="font-family:'宋体'; font-weight:bold">同意</span><span
        style="font-family:'宋体'; font-weight:bold">接受本服务协议时，视为甲方已签署本服务协议</span><span
        style="font-family:'宋体'; font-weight:bold">并生效</span><span style="font-family:'宋体'; font-weight:bold">。</span>
    </p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">甲方签署本服务协议后，表明甲方已知悉并同意遵守章程及本服务协议，并接受其约束。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">第二条</span><span style="font-family:'宋体'"> </span><span
        style="font-family:'宋体'">信息披露</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'; font-weight:bold">（一）</span><span
        style="font-family:'宋体'; font-weight:bold">甲方办理借记卡即视为同意授权乙方因提供借记卡服务所需获取、存储甲方的相关信息。甲方应向乙方提供真实、准确、完整、有效的资料。乙方承诺对甲方的申请资料及相关信息按照法律法规规定履行保密义务，采取有效措施保护</span><span
        style="font-family:'宋体'; font-weight:bold">甲方</span><span
        style="font-family:'宋体'; font-weight:bold">信息安全，且仅在为</span><span
        style="font-family:'宋体'; font-weight:bold">甲方</span><span
        style="font-family:'宋体'; font-weight:bold">提供本服务</span><span
        style="font-family:'宋体'; font-weight:bold">服务</span><span
        style="font-family:'宋体'; font-weight:bold">之所需的期限内存储</span><span
        style="font-family:'宋体'; font-weight:bold">甲方</span><span
        style="font-family:'宋体'; font-weight:bold">的个人信息，未经甲方同意不得向任何单位或个人披露。但甲方同意在以下情况授权乙方向第三方提供甲方信息：</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'等线'; font-weight:bold">1</span><span
        style="font-family:'宋体'; font-weight:bold">．</span><span
        style="font-family:'宋体'; font-weight:bold">乙方按照国家法律法规监管规定向监管机构或国家有权机关提供甲方相关信息。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'等线'; font-weight:bold">2</span><span
        style="font-family:'宋体'; font-weight:bold">．乙方因实施催收和追索欠款等维护自身合法权益的需要向催收服务外包单位提供服务必要的甲方相关信息。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'等线'; font-weight:bold">3</span><span
        style="font-family:'宋体'; font-weight:bold">．根据甲方申请为甲方制作</span><span
        style="font-family:'等线'; font-weight:bold">/</span><span
        style="font-family:'宋体'; font-weight:bold">邮寄借记卡实体卡的需要向银行卡制卡外包单位和承运单位提供必要的甲方相关信息。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'等线'; font-weight:bold">4. </span><span
        style="font-family:'宋体'; font-weight:bold">乙方因履行反洗钱监管要求</span><span
        style="font-family:'等线'; font-weight:bold">,</span><span
        style="font-family:'宋体'; font-weight:bold">对甲方信息进行核实或开展尽职调查时</span><span
        style="font-family:'等线'; font-weight:bold">,</span><span
        style="font-family:'宋体'; font-weight:bold">可以向第三方提供甲方的信息。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'等线'; font-weight:bold">5.</span><span
        style="font-family:'宋体'; font-weight:bold">根据甲方申请开立他行</span><span
        style="font-family:'等线'; font-weight:bold">Ⅱ</span><span
        style="font-family:'宋体'; font-weight:bold">类户电子借记卡或</span><span
        style="font-family:'等线'; font-weight:bold">Ⅲ</span><span
        style="font-family:'宋体'; font-weight:bold">类户电子借记卡时，将本行借记卡账户作为绑定账户，经开户银行发起身份验证时，同意乙方将甲方指定借记卡相关的必要个人信息包括但不限于姓名、身份证号、手机号码、银行卡信息等与开户银行及其委托单位上送的</span><span
        style="font-family:'宋体'; font-weight:bold">个人信息比对验证，并将对比核验结果告知开户银行及其委托单位，并留存核验记录。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'等线'; font-weight:bold">6</span><span
        style="font-family:'等线'; font-weight:bold">.</span><span
        style="font-family:'宋体'; font-weight:bold">法律法规监管另有规定或双方其他约定的。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span
        style="font-family:'宋体'; font-weight:bold">（二）甲方办理联名借记卡即视同愿意接受卡片联名方的服务，因联名方用于提供联名卡服务所需甲方授权乙方将持卡人的手机号码等相关信息提供给联名方。</span>
    </p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'; font-weight:bold">（三）</span><span
        style="font-family:'宋体'; font-weight:bold">其他因提供服务需要而需甲方授权乙方将甲方相关信息提供给第三方的，乙方应将信息使用的目的、范围和具体情形告知甲方并由甲方自行选择是否继续办理。甲方选择办理的，即视为理解并同意上述条款内容。</span>
    </p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">第三条</span><span style="font-family:'宋体'"> </span><span
        style="font-family:'宋体'">借记卡服务</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; font-size:10.5pt">
      <span style="font-family:'宋体'">（一）借记卡具有有效期。</span><span
        style="font-family:'宋体'; font-weight:bold">实体借记卡有效期</span><span
        style="font-family:'宋体'; font-weight:bold">以卡片载明的有效期为准</span><span
        style="font-family:'宋体'; font-weight:bold">，有效期到期后甲方应持本人有效身份证件办理换卡手续；</span><span
        style="font-family:'宋体'">电子借记卡有效期可通过乙方渠道查询，电子借记卡有效期到期时</span><span style="font-family:'宋体'">将</span><span
        style="font-family:'宋体'">自动延长一个有效期周期，退市产品除外。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; font-size:10.5pt">
      <span style="font-family:'宋体'; font-weight:bold">借记卡</span><span
        style="font-family:'宋体'; font-weight:bold">有效期过期后，通过受理实体卡发生的交易受限，</span><span
        style="font-family:'宋体'">但通过电子渠道发生的交易不受限制。</span><span
        style="font-family:'宋体'">如乙方已提示甲方过期但甲方未及时办理新卡更换手续而造成卡片无法正常使用的，乙方不承担任何责任。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; font-size:10.5pt">
      <span style="font-family:'宋体'">对已过期的借记卡，甲方使用借记卡期间所发生的债权债务关系不变。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（二）甲方可申请实体借记卡，也可申请电子借记卡。甲方申请电子借记卡</span><span
        style="font-family:'宋体'">的，</span><span style="font-family:'宋体'">电子借记卡的备用金账户为</span><span
        style="font-family:'等线'">I</span><span style="font-family:'宋体'">类户或Ⅱ类普通账户</span><span
        style="font-family:'宋体'">且</span><span style="font-family:'宋体'">经乙方人员面对面核实身份</span><span
        style="font-family:'宋体'">后</span><span style="font-family:'宋体'">，</span><span
        style="font-family:'宋体'">方可</span><span style="font-family:'宋体'">再申请将电子借记卡换成实体借记卡。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（三）</span><span
        style="font-family:'宋体'">甲方可向乙方申请将借记卡实体卡选择以邮寄方式寄送甲方指定地址。实体借记卡邮寄至甲方指定的地址是乙方提供的增值服务，</span><span
        style="font-family:'宋体'; font-weight:bold">甲方自主选择该服务并支付增值服务费。</span><span
        style="font-family:'宋体'">甲方申请邮寄领卡，应确保提供的邮寄信息完整、真实、准确并确保按时收件。</span><span
        style="font-family:'宋体'; font-weight:bold">如因甲方提供的邮寄信息不真实、不完整、不准确、无法联系、无法签收等甲方原因造成邮寄服务方按照甲方在乙方处预留的信息联系甲方收件失败或未及时签收等原因导致的邮寄不达，乙方不承担责任</span><span
        style="font-family:'宋体'">；对于因乙方或乙方邮寄服务方原因造成的邮寄不达，乙方将安排免费重邮。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（四）甲方申请将借记卡邮寄至甲方指定地址的，为确保邮寄途中的卡片安全，</span><span
        style="font-family:'宋体'; font-weight:bold">甲方收到实体卡后应通过乙方指定渠道启用实体卡后方可使用。</span><span
        style="font-family:'宋体'">如实体卡在邮寄途中遗失、损坏等，甲方可向乙方申请作废该实体卡或由乙方自主作废该实体卡。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">甲方可向乙方申请将借记卡实体卡邮寄至乙方网点，</span><span
        style="font-family:'宋体'; font-weight:bold">自实体卡到达乙方网点且乙方通知甲方领卡之日起</span><span
        style="font-family:'等线'; font-weight:bold">6</span><span
        style="font-family:'宋体'; font-weight:bold">个月内甲方未至发卡机构网点领取，发卡机构有权对借记卡实体卡进行作废处理。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（五）</span><span
        style="font-family:'宋体'; font-weight:bold">为便利甲方的小额交易用卡，乙方发行的带有“闪付”或“</span><span
        style="font-family:'等线'; font-weight:bold">QuickPass</span><span
        style="font-family:'宋体'; font-weight:bold">”标识的银联</span><span
        style="font-family:'等线'; font-weight:bold">IC</span><span
        style="font-family:'宋体'; font-weight:bold">卡支持开通小额免密免签功能，甲方可根据需要选择开通。</span><span
        style="font-family:'宋体'; font-weight:bold">甲方开通</span><span
        style="font-family:'宋体'; font-weight:bold">小额免密免签功能后</span><span
        style="font-family:'宋体'; font-weight:bold">在境内银联指定商户进行一定金额以下的“闪付”交易时，</span><span
        style="font-family:'宋体'; font-weight:bold">只需将卡片靠近受理终端感应区即可完成支付，</span><span
        style="font-family:'宋体'; font-weight:bold">无需验证密码，也无需在打印凭证上签名。小额免密免签功能的限额以乙方对外公布的限额为准并可经乙方通过公告等方式告知甲方后调整。</span><span
        style="font-family:'宋体'; font-weight:bold">甲方可通过乙方渠道开通、查询、调整免密限额或关闭该功能。上述规则如银联卡组织调整，则以调整后的规则为准。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（六）甲方遗失或卡号泄露等，应立即向乙方申请借记卡挂失，挂失成功后借记卡不可对外支付，</span><span
        style="font-family:'宋体'; font-weight:bold">但挂失前已签约本行绑定卡关联还贷款</span><span
        style="font-family:'等线'; font-weight:bold">/</span><span
        style="font-family:'宋体'; font-weight:bold">信用卡的业务不受影响（另有其他约定的除外）</span><span style="font-family:'宋体'">。</span>
    </p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">借记卡挂失分为口头挂失和书面挂失，甲方可通过乙方的电话银行、网上银行或营业网点办理口头挂失</span><span
        style="font-family:'宋体'">，</span><span style="font-family:'宋体'">或通过乙方的营业网点办理书面挂失。</span><span
        style="font-family:'宋体'; font-weight:bold">口头挂失不作为办理补卡或销卡的依据，持卡人如需办理补卡或销卡必须先办理书面挂失。</span><span
        style="font-family:'宋体'; font-weight:bold">口头挂失或书面挂失自办妥之时</span><span
        style="font-family:'宋体'; font-weight:bold">生效，</span><span
        style="font-family:'宋体'; font-weight:bold">挂失生效前的经济损失由甲方自行承担。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span
        style="font-family:'宋体'">甲方可向乙方申请将已挂失的借记卡解除挂失，解挂后该借记卡恢复对外支付功能。甲方也可向乙方申请对已挂失的借记卡进行补卡，为了甲方的用卡安全，补卡后新卡卡号不同于老卡卡号。</span>
    </p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（七）自挂失生效后，发生的非甲方真实交易意愿及授权而造成的债务和损失不再由甲方承担，</span><span
        style="font-family:'宋体'; font-weight:bold">但因以下情况造成的债务和损失除</span><span
        style="font-family:'宋体'; font-weight:bold">外：</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'等线'; font-weight:bold">1.</span><span
        style="font-family:'宋体'; font-weight:bold">甲</span><span
        style="font-family:'宋体'; font-weight:bold">方有</span><span
        style="font-family:'宋体'; font-weight:bold">欺诈</span><span
        style="font-family:'宋体'; font-weight:bold">或</span><span
        style="font-family:'宋体'; font-weight:bold">其</span><span
        style="font-family:'宋体'; font-weight:bold">他虚假</span><span
        style="font-family:'宋体'; font-weight:bold">行为的；</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'等线'; font-weight:bold">2.</span><span
        style="font-family:'宋体'; font-weight:bold">甲方拒绝配合乙方开展必要的调查核实工作的。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span
        style="font-family:'宋体'">（八）因卡片损坏、卡片升级或者卡片有效期到期等原因，甲方可向乙方申请换卡。甲方申请实时换卡，换卡成功新卡可当场领取并激活，老卡当场作废，乙方不回收老卡实体卡；甲方也可申请预约换卡，申请预约换卡至新卡启用期间，原卡仍然有效，新卡启用同时原卡作废。</span>
    </p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span
        style="font-family:'宋体'">申请预约换卡至新卡启用期间：如甲方撤销预约换卡，撤销成功原预约换卡记录失效；如甲方办理老卡正式挂失，则原预约换卡记录失效，如甲方仍须换卡则应撤销预约后按挂失补卡流程办理；如甲方办理了原卡销卡，则原预约换卡记录失效。特殊类型的卡片（如地方性联名卡等）暂不提供异地换卡服务。</span>
    </p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（九）</span><span
        style="font-family:'宋体'; font-weight:bold">甲方办理借记卡的补卡或换卡后，不影响原有</span><span
        style="font-family:'宋体'; font-weight:bold">债权</span><span
        style="font-family:'宋体'; font-weight:bold">债务责任的承担，原借记卡内</span><span
        style="font-family:'宋体'; font-weight:bold">开办的各类签约业务功能是否可以自动转至新卡，以甲方签订的相关业务协议约定为准。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（十）</span><span style="font-family:'宋体'">对账服务</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">甲方可通过乙方营业网点、客户服务电话、网上银行、手机银行、微信银行、自助终端、短信通知等渠道和方式了解其借记卡账户内的账务变动情况。</span><span
        style="font-family:'宋体'; font-weight:bold">甲方对交易账务变动情况有异议的，应于交易发生之日起</span><span
        style="font-family:'等线'; font-weight:bold">30</span><span
        style="font-family:'宋体'; font-weight:bold">天内向乙方提出查询更正申请，否则视为甲方同意并接受所有账务情况的变动内容。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（十一）</span><span style="font-family:'宋体'; font-weight:bold">开立本行或他行</span><span
        style="font-family:'等线'; font-weight:bold">Ⅱ</span><span
        style="font-family:'宋体'; font-weight:bold">类户电子借记卡或</span><span
        style="font-family:'等线'; font-weight:bold">Ⅲ</span><span
        style="font-family:'宋体'; font-weight:bold">类户电子借记卡时，</span><span
        style="font-family:'宋体'; font-weight:bold">所</span><span
        style="font-family:'宋体'; font-weight:bold">绑定</span><span
        style="font-family:'宋体'; font-weight:bold">的银行卡由于挂失、止付、有效期到期等原因不能正常使用时，客户应当到开户机构指定的渠道办理变更，否则由此产生的一切后果由客户承担。</span>
    </p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">第</span><span style="font-family:'宋体'">四条</span><span style="font-family:'宋体'">
      </span><span style="font-family:'宋体'">借记卡交易</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（一）</span><span style="font-family:'宋体'">甲</span><span
        style="font-family:'宋体'">方</span><span style="font-family:'宋体'">收到实体</span><span
        style="font-family:'宋体'">借记卡</span><span style="font-family:'宋体'">之</span><span
        style="font-family:'宋体'">后，须立即</span><span style="font-family:'宋体'">在</span><span
        style="font-family:'宋体'">卡片</span><span style="font-family:'宋体'">背面签</span><span
        style="font-family:'宋体'">名条上</span><span style="font-family:'宋体'">签署本人的姓</span><span
        style="font-family:'宋体'">名。</span><span style="font-family:'宋体'">甲</span><span
        style="font-family:'宋体'">方的</span><span style="font-family:'宋体'">签</span><span
        style="font-family:'宋体'">名应与其</span><span style="font-family:'宋体'">提供给</span><span
        style="font-family:'宋体'">乙</span><span style="font-family:'宋体'">方的申请证件上所</span><span
        style="font-family:'宋体'">载</span><span style="font-family:'宋体'">姓名一</span><span
        style="font-family:'宋体'">致，签名可选任意字体</span><span style="font-family:'宋体'">。甲方</span><span
        style="font-family:'宋体'">在用卡时应使用该签名。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（二）为</span><span style="font-family:'宋体'">获</span><span
        style="font-family:'宋体'">得</span><span style="font-family:'宋体'">货</span><span
        style="font-family:'宋体'">品</span><span style="font-family:'宋体'">或服</span><span
        style="font-family:'宋体'">务，甲方</span><span style="font-family:'宋体'">每</span><span
        style="font-family:'宋体'">一</span><span style="font-family:'宋体'">项</span><span
        style="font-family:'宋体'">通过</span><span style="font-family:'宋体'">邮</span><span
        style="font-family:'宋体'">件、</span><span style="font-family:'宋体'">电话</span><span
        style="font-family:'宋体'">、</span><span style="font-family:'宋体'">传</span><span
        style="font-family:'宋体'">真、</span><span style="font-family:'宋体'">互</span><span
        style="font-family:'宋体'">联</span><span style="font-family:'宋体'">网或</span><span
        style="font-family:'宋体'">其</span><span style="font-family:'宋体'">他</span><span
        style="font-family:'宋体'">任何</span><span style="font-family:'宋体'">方</span><span
        style="font-family:'宋体'">式并使用</span><span style="font-family:'宋体'">借记卡向商家进行的支</span><span
        style="font-family:'宋体'">付</span><span style="font-family:'宋体'">，均</span><span
        style="font-family:'宋体'">构</span><span style="font-family:'宋体'">成一</span><span
        style="font-family:'宋体'">项</span><span style="font-family:'宋体'">有</span><span
        style="font-family:'宋体'">效</span><span style="font-family:'宋体'">的借记卡</span><span
        style="font-family:'宋体'">交易</span><span style="font-family:'宋体'">，</span><span
        style="font-family:'宋体'">乙</span><span style="font-family:'宋体'">方将</span><span
        style="font-family:'宋体'">在</span><span style="font-family:'宋体'">甲</span><span
        style="font-family:'宋体'">方的借记卡中</span><span style="font-family:'宋体'">就</span><span
        style="font-family:'宋体'">该</span><span style="font-family:'宋体'">等</span><span
        style="font-family:'宋体'">交易</span><span style="font-family:'宋体'">进行借</span><span
        style="font-family:'宋体'">记</span><span style="font-family:'宋体'">。</span><span
        style="font-family:'宋体'">甲方不得以与商户或其它第三方存在纠纷等情形为由，拒绝支付其以借记卡完成支付所欠的款项。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（三）</span><span
        style="font-family:'宋体'; font-weight:bold">因不可抗力或非因乙方过错引起的系统、供电、通讯、网络故障等各项原因导致甲方用卡失败而造成损失的，乙方有义务协助甲方解决问题或提供必要的帮助，但不承担经济或法律责任。</span>
    </p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（四）</span><span style="font-family:'宋体'">甲方在使用</span><span
        style="font-family:'宋体'">借记卡</span><span style="font-family:'宋体'">进行联机</span><span
        style="font-family:'等线'">/</span><span
        style="font-family:'宋体'">脱机消费、存取现金及转账等交易时，须遵守法律法规监管规定、乙方、银行卡清算机构、收单机构及有关受理机构的相关规定。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（五）</span><span style="font-family:'宋体'; font-weight:bold">甲</span><span
        style="font-family:'宋体'; font-weight:bold">方使用借记卡开展交易取现、转账、消费等各类交易时，乙方有权根据</span><span
        style="font-family:'宋体'; font-weight:bold">国家法律法规监管规定以及乙方风险控制策略设置不同交易类型的交易限额，包括但不限于</span><span
        style="font-family:'宋体'; font-weight:bold">交易渠道</span><span
        style="font-family:'宋体'; font-weight:bold">限制</span><span
        style="font-family:'宋体'; font-weight:bold">、</span><span
        style="font-family:'宋体'; font-weight:bold">金额限制、笔数限制</span><span
        style="font-family:'宋体'; font-weight:bold">等</span><span
        style="font-family:'宋体'; font-weight:bold">，并有权根据国家法律法规监管规定及乙方业务变化等因素对相关限额进行调整。</span><span
        style="font-family:'宋体'">甲方在香港特别行政区、澳门特别行政区、台湾地区和境外</span><span style="font-family:'等线'">ATM</span><span
        style="font-family:'宋体'">提取现金的，除应遵守国家法律法规监管规定外，还应遵守所在地区或国家的法律、法规和受理机构相关规定。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（六）</span><span
        style="font-family:'宋体'; font-weight:bold">转账交易涉及有权机关依法发起冻结或强制扣划的，甲方知悉并授权乙方撤销在途的</span><span
        style="font-family:'等线'; font-weight:bold">ATM</span><span
        style="font-family:'宋体'; font-weight:bold">跨行转账交易。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'; font-weight:bold">如任何非甲方应得款项错误存入甲方账户，经乙方查实的，甲方授权乙方从甲方账户中扣转该笔款项。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（七）甲方使用</span><span style="font-family:'等线'">ATM</span><span
        style="font-family:'宋体'">等自助设备时，如发生吞卡，应及时与自助设备所属机构取得联系，并按照其指定要求办理领卡手续。过期未领的，乙方将按照有关规定对被吞卡片进行销毁处理，甲方如需继续使用，须到乙方网点办理补卡手续；甲方在其他银行</span><span
        style="font-family:'等线'">ATM</span><span style="font-family:'宋体'">等自助设备发生吞卡的，应及时按照他行相关规定办理手续。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（八）</span><span
        style="font-family:'宋体'; font-weight:bold">根据银联卡业务规则对于银联渠道下的预授权交易的规定，</span><span
        style="font-family:'宋体'; font-weight:bold">甲</span><span
        style="font-family:'宋体'; font-weight:bold">方进行</span><span
        style="font-family:'宋体'; font-weight:bold">预授</span><span
        style="font-family:'宋体'; font-weight:bold">权</span><span
        style="font-family:'宋体'; font-weight:bold">交易</span><span
        style="font-family:'宋体'; font-weight:bold">时，</span><span
        style="font-family:'宋体'; font-weight:bold">乙</span><span
        style="font-family:'宋体'; font-weight:bold">方将</span><span
        style="font-family:'宋体'; font-weight:bold">按照交易</span><span
        style="font-family:'宋体'; font-weight:bold">金额的</span><span
        style="font-family:'等线'; font-weight:bold">115</span><span
        style="font-family:'等线'; font-weight:bold">%</span><span
        style="font-family:'宋体'; font-weight:bold">对甲方借记卡的可用余额（备用金账户余额</span><span
        style="font-family:'等线'; font-weight:bold">+</span><span
        style="font-family:'宋体'; font-weight:bold">约定类账户余额</span><span
        style="font-family:'等线'; font-weight:bold">-</span><span
        style="font-family:'宋体'; font-weight:bold">已冻结或锁定金额）进行</span><span
        style="font-family:'宋体'; font-weight:bold">资</span><span
        style="font-family:'宋体'; font-weight:bold">金</span><span
        style="font-family:'宋体'; font-weight:bold">锁</span><span
        style="font-family:'宋体'; font-weight:bold">定，</span><span
        style="font-family:'宋体'; font-weight:bold">锁</span><span
        style="font-family:'宋体'; font-weight:bold">定后的</span><span
        style="font-family:'宋体'; font-weight:bold">资</span><span
        style="font-family:'宋体'; font-weight:bold">金将</span><span
        style="font-family:'宋体'; font-weight:bold">不</span><span
        style="font-family:'宋体'; font-weight:bold">能</span><span
        style="font-family:'宋体'; font-weight:bold">被甲</span><span
        style="font-family:'宋体'; font-weight:bold">方用作</span><span
        style="font-family:'宋体'; font-weight:bold">包</span><span
        style="font-family:'宋体'; font-weight:bold">括</span><span
        style="font-family:'宋体'; font-weight:bold">取现在内的任</span><span
        style="font-family:'宋体'; font-weight:bold">何</span><span
        style="font-family:'宋体'; font-weight:bold">用</span><span
        style="font-family:'宋体'; font-weight:bold">途</span><span
        style="font-family:'宋体'; font-weight:bold">的支</span><span
        style="font-family:'宋体'; font-weight:bold">付</span><span
        style="font-family:'宋体'; font-weight:bold">。</span><span
        style="font-family:'宋体'; font-weight:bold">上述规则如银联卡组织调整，则以调整后的规则为准。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（九）</span><span
        style="font-family:'宋体'">乙方系统对借记卡密码采用密码录入错误限次管理。交易密码连续发生输入错误三次的，卡片将被锁定，甲方如需继续使用，须由本人持该卡并凭有效身份证件通过乙方渠道办理解锁手续。</span>
    </p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（十）根据法律法规监管规定和基于保护持卡人资金安全目的，发卡机构有权拒绝承兑涉嫌赌、</span><span
        style="font-family:'宋体'">诈骗、非法集资、</span><span style="font-family:'宋体'">洗钱</span><span
        style="font-family:'宋体'">、金融制裁</span><span
        style="font-family:'宋体'">等违反国家法律法规监管规定的互联网交易或暂停借记卡使用及相关服务。因可能涉及非法交易所导致的损失及责任由持卡人自行承担。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">第五条</span><span style="font-family:'宋体'"> </span><span
        style="font-family:'宋体'">电子现金账户</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（一）实体借记卡为芯片卡或磁条芯片复合卡的，其所载芯片符合人民银行金融</span><span
        style="font-family:'等线'">IC</span><span style="font-family:'宋体'">卡相关标准，可以加载非金融应用</span><span
        style="font-family:'宋体'">。甲方对借记卡进行</span><span style="font-family:'宋体'">圈存</span><span
        style="font-family:'宋体'">交易时</span><span style="font-family:'宋体'">联动开立</span><span
        style="font-family:'宋体'">电子现金账户。</span><span
        style="font-family:'宋体'; font-weight:bold">电子现金账户资金不计息、不挂失，不提供对账单服务，余额上限遵从法律法规监管规定。电子现金账户可进行圈存、脱机消费和查询，不提供支取现金和转账等其他支付结算功能，电子现金账户消费时不需进行密码验证。</span><span
        style="font-family:'宋体'; font-weight:bold">开通电子现金账户时同步开通电子现金补登账户。</span><span
        style="font-family:'宋体'; font-weight:bold">电子现金补登账户为借记卡用于</span><span
        style="font-family:'宋体'; font-weight:bold">脱机消费退货资金核算和补换卡电子现金余额资金的账户，该账户内存款不计息。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（二）甲方借记卡电子现金在换卡</span><span style="font-family:'等线'">/</span><span
        style="font-family:'宋体'">补卡</span><span style="font-family:'等线'">/</span><span
        style="font-family:'宋体'">销卡时退还约定</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">办理换卡</span><span style="font-family:'等线'">/</span><span
        style="font-family:'宋体'">补卡</span><span style="font-family:'等线'">/</span><span
        style="font-family:'宋体'">销卡业务之前或之后，甲方可持老卡实体卡至乙方网点申请退还电子现金余额，并指定电子现金的退还方式。包括如下三种情形：</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'等线'">1.</span><span style="font-family:'宋体'">老卡可读，通过圈提方式将电子现金余额退还甲方，并对老卡作销毁处理；</span>
    </p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'等线'">2.</span><span style="font-family:'宋体'">老卡不可读，将于成功受理甲方退还电子现金余额申请之日起</span><span
        style="font-family:'等线'">30</span><span style="font-family:'宋体'">天后，按照甲方系统记录的电子现金账户余额退还甲方。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'等线'">3.</span><span style="font-family:'宋体'">甲方无法提供老卡，将于该实体借记卡有效期到期日</span><span
        style="font-family:'等线'">30</span><span style="font-family:'宋体'">天后，按照甲方系统记录的电子现金账户余额退还甲方。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span
        style="font-family:'宋体'">退还资金方式有转账和现金两种，甲方可以在销卡时约定退还资金转入的乙方借记卡卡号，或者凭本人有效身份证件到乙方营业网点领取现金；若转账失败，则甲方须按照现金领取的规则领取。</span>
    </p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'; font-weight:bold">第六条</span><span style="font-family:'宋体'; font-weight:bold">
      </span><span style="font-family:'宋体'; font-weight:bold">专用借记卡</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'; font-weight:bold">（一）甲方</span><span
        style="font-family:'宋体'; font-weight:bold">通过与乙方合作的第三方开立借记卡的，仅限在合作方渠道消费的借记卡为专用借记卡，该专用借记卡仅限</span><span
        style="font-family:'宋体'; font-weight:bold">II</span><span
        style="font-family:'宋体'; font-weight:bold">类户借记卡或</span><span
        style="font-family:'宋体'; font-weight:bold">III</span><span
        style="font-family:'宋体'; font-weight:bold">类户借记卡。专用借记卡的备用金账户暂不支持升级为</span><span
        style="font-family:'宋体'; font-weight:bold">I</span><span
        style="font-family:'宋体'; font-weight:bold">类户、不支持配发实体卡、不支持换卡和补卡，可在乙方柜面办理密码设置、重置、默认不设置交易密码，除此之外的功能与通用借记卡一致。除专用借记卡外的借记卡均为通用借记卡，通用借记卡具备监管规定许可范围内所有功能。</span>
    </p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'; font-weight:bold">（二）专用借记卡在合作方渠道使用时，以短信动态密码或其他经符合合作方渠道要求的验证信</span><span
        style="font-family:'宋体'; font-weight:bold">息</span><span
        style="font-family:'宋体'; font-weight:bold">手段作为交易验证规则。凡使用密码</span><span
        style="font-family:Calibri; font-weight:bold">/</span><span
        style="font-family:'宋体'; font-weight:bold">短信动态验证码或符合约定的身份验证方式验证通过的借记卡交易，均视为客户本人所为。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">第七条</span><span style="font-family:'宋体'">其他</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（一）</span><span
        style="font-family:'宋体'">甲方违反有关法律法规监管规定或相关协议约定并给乙方造成损失的，乙方依法采取法律措施维护合法权益并依法追究甲方及有关当事人的法律责任。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span
        style="font-family:'宋体'">（二）乙方有权根据国家法律法规监管规定以及经营需要修改本协议，修改后的协议在乙方的营业网点、网站等渠道进行公告。公告期满后修改后的协议即生效，乙方无须另行通知甲方。在公告期内，甲方可选择是否继续使用借记卡及相关服务。甲方因对协议的修改有异议而决定不继续使用借记卡及相关服务的，可在公告期满前通过乙方渠道办理销卡。公告期满甲方未销卡的，即视为同意接受公告的各项内容。</span>
    </p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（三）本协议</span><span style="font-family:'宋体'">适</span><span
        style="font-family:'宋体'">用中</span><span style="font-family:'宋体'">华</span><span
        style="font-family:'宋体'">人民</span><span style="font-family:'宋体'">共</span><span
        style="font-family:'宋体'">和国法律（为本协议目的，</span><span style="font-family:'宋体'">在</span><span
        style="font-family:'宋体'">此</span><span style="font-family:'宋体'">不包</span><span
        style="font-family:'宋体'">括香港特别行政区</span><span style="font-family:'宋体'">、</span><span
        style="font-family:'宋体'">澳</span><span style="font-family:'宋体'">门特</span><span
        style="font-family:'宋体'">别</span><span style="font-family:'宋体'">行</span><span
        style="font-family:'宋体'">政区</span><span style="font-family:'宋体'">以</span><span
        style="font-family:'宋体'">及</span><span style="font-family:'宋体'">台湾</span><span
        style="font-family:'宋体'">地</span><span style="font-family:'宋体'">区的法律</span><span
        style="font-family:'宋体'">）</span><span style="font-family:'宋体'">。</span><span
        style="font-family:'宋体'">双</span><span style="font-family:'宋体'">方</span><span
        style="font-family:'宋体'">一致</span><span style="font-family:'宋体'">同意</span><span
        style="font-family:'宋体'">接</span><span style="font-family:'宋体'">受由</span><span
        style="font-family:'宋体'">乙</span><span style="font-family:'宋体'">方所</span><span
        style="font-family:'宋体'">在</span><span style="font-family:'宋体'">地有管辖权的法</span><span
        style="font-family:'宋体'">院</span><span style="font-family:'宋体'">进行</span><span
        style="font-family:'宋体'">排</span><span style="font-family:'宋体'">他</span><span
        style="font-family:'宋体'">性的司法管辖，本协议当事人另有约定的除外。本协议</span><span style="font-family:'宋体'">未</span><span
        style="font-family:'宋体'">尽</span><span style="font-family:'宋体'">事</span><span
        style="font-family:'宋体'">宜</span><span style="font-family:'宋体'">依据国家法律法规监管规定及《上海浦东发展银行借记卡章程》执行。</span></p>


        <br/>
        <br/>

        <p style=" font-weight: bold; font-size: 16px;text-align:center">
          上海浦东发展银行个人开户申请书
        </p>
        <p style=" font-weight: bold; font-size: 16px;text-align:center">
          开户须知（2022年8月版）
        </p>
        <p class="distance_50">
          一、本须知适用于申请人（或其合法监护人，下同）在上海浦东发展银行（以下简称“浦发银行”）开立各类存折、存单和借记卡业务。
        </p>
        <p class="distance_50">
          二、申请人自愿在浦发银行开立个人银行账户。申请人须遵守国家法律法规、监管机构规定及与浦发银行就开立个人账户签署相关协议的有关约定。
        </p>
        <p class="distance_50">
          三、申请人充分了解并清楚知晓出租、出借、出售、转让、冒用、冒领、购买等使用非本人账户的相关法律责任和浦发银行根据法律法规、监管机构规定和申请人已签署有关协议的约定采取相关措施，承诺依法依规开立和使用本人账户。
        </p>
        <p class="distance_50">
          四、申请人开立个人银行账户时须保证向浦发银行提供符合《个人存款账户实名制规定》（中华人民共和国国务院令第285号）及其他相关规定的所需资料，并保证据实、完整、合法地填写开户申请书及其他相关资料。如委托他人代为开立个人银行账户，则委托人须保证应当遵守前述约定，同时还须保证账户申请人同意和遵守申请书和开户须知的约定。申请人申请开立账户遵照有关法律法规和监管机构关于个人银行结算账户分类、使用、管理等规定。
        </p>
        <p class="distance_50">
          五、申请人同意浦发银行以浦发银行公告的收费内容和收费标准对个人账户的管理或其他服务收取费用。
        </p>
        <p class="distance_50">
          六、申请人于开户时预留的个人信息或资料发生变动时，应及时通知浦发银行进行修改，因申请人未及时通知浦发银行，造成业务不能如期办理及其他后果的，申请人自行承担相关责任。
        </p>
        <p class="distance_50">
          七、申请人同意借记卡、活期一本通的人民币活期账户自动设置为个人结算账户，当有外币资金入账时，借记卡、活期一本通将自动开立相应外币活期储蓄账户。申请人保证其对个人结算账户以及外币活期储蓄账户的使用遵守中国人民银行、国家外汇管理局等金融监管机构有关账户管理的规定，并定期与浦发银行核对账务。
        </p>
        <p class="distance_50">
          八、借记卡、各类存折、存单遗失、被盗或密码遗忘、泄露的，申请人应及时向浦发银行申请挂失，申请人在申请挂失（含口头挂失）前账户资金被支取，由申请人自行承担相关责任。
        </p>
        <p class="distance_50">
          九、申请人在银行进行余额查询、打印时，所显示的余额可能包含申请人因使用P0S消费等行为已经发生支付的金额（因商户结算周期等原因，消费金额尚未被扣除）。
        </p>
        <p class="distance_50">
          十、申请人应妥善保管账号、密码等资料，不得将本人账户转借给他人使用。因申请人本人资料泄露或将本人账户转借他人使用产生的风险，损失及其他后果均由申请人自行承担。
        </p>
        <p class="distance_50">
          十一、浦发银行仅通过我行特别号码95528、106980095528、106905695528、1069402595528、1069270395528、106913595528、106934095528、1069116095528、1069039095528向客户发送所有短信通知和其他信息，申请人务必注意识别，以防范虚假短信。浦发银行将通过官方网站（www.spdb.com.cn）及时公示号码变更情况，请申请人关注。
        </p>
        <p class="distance_50">
          十二、因通讯异常及其他不可抗力因素或申请人原因造成的风险和损失，浦发银行不承担责任。
        </p>
        <p class="distance_50">
          十三、在申请人开立于浦发银行的任何账户的存续期间，若违反浦发银行反洗钱管理规定、或浦发银行具备合理理由怀疑申请人及其业务涉嫌参与联合国安理会、反洗钱金融行动特别工作组、中国、美国、欧盟、英国、新加坡等国际组织或国家认定的洗钱、制裁、恐怖融资、大规模杀伤性武器扩散融资活动、逃税、出口管制等违法违规行为的，浦发银行有权按照中国人民银行反洗钱监管规定等规定及内部管理规定，对申请人全部或部分账户采取中止服务和／或销户等必要的管控措施，且不承担任何责任。
        </p>
        <p class="distance_50">
          十四、申请人通过开立于浦发银行的任何账户所办理的业务，如涉嫌参与前述洗钱、恐怖融资或扩散（大规模杀伤性武器）融资等活动，导致浦发银行向申请人提供服务时遭受损失的，申请人应向浦发银行承担赔偿责任。赔偿责任的范围包括但不限于浦发银行由于申请人的活动被境内外司法机关裁判承担的损失，境内外政府机构或监管机关对于浦发银行为申请人的活动提供服务所进行的处罚以及浦发银行为应对上述情形采取措施所产生的一切费用和损失等。
        </p>
        <p class="distance_50">
          十五、申请人已完全知悉并接受浦发银行借记卡章程及领用协议的全部内容，并保证遵守浦发银行借记卡章程及领用协议的约定。
        </p>
        <p class="distance_50">
          十六、申请人同意借记卡、定期一本通、定期存单中的整存整取定期存款到期后由本行代为自动转存。
        </p>
        <p class="distance_50">
          十七、申请人所持借记卡每日在ATM机上提款的最高限额和次数按监管机构的规定执行。
        </p>
        <p class="distance_50">
          十八、说明：①中国内地税收居民的定义请见国家税务总局网站(http://www.chinatax.gov.cn/aeoi_index.html）的相关定义。②非居民是指中国内地税收居民以外的个人。其他国家（地区）税收居民身份认定规则及纳税人识别号相关信息请参见国家税务总局网站(http://www.chinatax.gov.cn/aeoi_index.html)。③居住地址是指账户持有人税收居民国（地区）的地址，不是中国代理人的地址，也不是在中国临时居住的地址。④税收居民国（地区）为美国的，必须填报纳税人识别号。美国个人是指具有美国国籍，持有美国绿卡或者在美国长期停留的个人。在美国长期停留是指：当年在美国停留31天以上，并在3年内累计超过183天。累计方式是当年每一天算一天，去年每一天算1/3天，前一年每一天算1/6天。⑤军人、武装警察无需填写税收居民身份声明文件。
        </p>
        <p class="distance_50">
          十九、在浦发银行为申请人提供产品或服务所必需的情形下，申请人自愿同意并授权浦发银行在符合法律法规及监管机构规定的前提下采集、传输、处理、保存申请人的姓名、证件号码、银行卡号、手机号等相关个人信息，主要用于为申请人提供开立各类存折、存单和借记卡等产品或服务，以及保障申请人账户及交易的安全。我行将按照法律法规和监管规定采取措施，保障申请人的个人信息安全。
        </p>
        <p class="distance_50">
          二十、鉴于国家有权机关关于开展非居民金融账户涉税信息尽职调查的要求，规范金融机构对非居民金融账户涉税信息的尽职调查行为，浦发银行需开展非居民金融账户涉税信息尽职调查的工作，识别非居民金融账户，收集并报送账户相关信息。浦发银行承诺对收集的相关信息承担保密义务，信息保存期限按照监管要求执行。
        </p>

        <br/>
        <br/>

        <p style=" font-weight: bold; font-size: 16px;text-align:center">
          上海浦东发展银行
        </p>
        <p style=" font-weight: bold; font-size: 16px;text-align:center">
          电子银行个人客户服务协议
        </p>
        <p class="distance_50">
          为明确双方的权利和义务，个人客户（以下简称“客户”）和上海浦东发展银行（以下简称“银行”）本着平等互利的原则，就电子银行服务相关事宜达成本协议，以资共同遵守。
        </p>
        <p class="distance_50">
          第一条 业务定义
        </p>
        <p class="distance_50">
          下列用语在本协议中的含义为：
        </p>
        <p class="distance_50">
          “电子银行”指银行通过面向社会公众开放的通讯通道或公共通讯网络，以及为特定自助服务设施或客户建立的专用网络等方式，为客户提供的离柜金融服务。根据服务渠道的不同，可分为个人网上银行服务、个人手机银行服务、及时语服务、电视银行服务、自助银行服务（包括自动柜员机、自动存款机、自动存取款机、多媒体自助服务机等自助设备，下同）等。
        </p>
        <p class="distance_50">
          “身份认证要素”指银行用于识别客户身份的信息要素，如客户号、登录昵称、账号、各类密码、数字证书、签约设置的电话或手机号码等。
        </p>
        <p class="distance_50">
          “密码”指客户确认身份的字符信息，分为客户查询密码、凭证（卡/折/单/电子账户等）交易密码和动态密码。动态密码以手机短信方式发送到客户预留的手机上。
        </p>
        <p class="distance_50">
          “数字证书”指用于存放客户身份标识，并对客户发送的电子银行交易信息进行数字签名的电子文件。
        </p>
        <p class="distance_50">
          “业务指令”指客户通过电子银行凭借相关的身份认证要素发起的查询、转账等电子指令的统称。
        </p>
        <p class="distance_50">
          第二条 服务内容
        </p>
        <p class="distance_50">
          （一）个人网上银行服务内容
        </p>
        <p class="distance_50">
          客户通过银行柜面或其它途径申请签约并办理相关手续后，即成为个人网上银行客户。个人网上银行客户可享受的服务包括：账户管理、投资理财、贷款融资、汇款支付、公共事业缴费等服务，以及申请开通或变更网上银行所提供的其他功能。
        </p>
        <p class="distance_50">
          （二）个人手机银行服务内容
        </p>
        <p class="distance">
          客户通过银行柜面或其它途径申请签约并办理相关手续后，即成为手机银行的签约客户。签约客户可享受的服务包括：账户管理、投资理财、汇款支付、公共事业缴费等服务，以及申请开通或变更手机银行所提供的其他功能。
        </p>
        <p class="distance_50">
          （三）及时语服务内容
        </p>
        <p class="distance_50">
          客户通过银行柜面或其它途径申请签约并办理相关手续后，即成为及时语服务的签约客户。签约客户可享受的服务包括：短信通知、短信查询、邮件通知等服务，以及申请开通或变更及时语服务所提供的其他功能。
        </p>
        <p class="distance_50">
          （四）电视银行服务内容
        </p>
        <p class="distance_50">
          客户通过银行柜面或其它途径申请签约并办理相关手续后，即成为电视银行的签约客户。签约客户可享受的服务包括：账户管理、投资理财、公共事业缴费等服务，以及申请开通或变更电视银行所提供的其他功能。
        </p>
        <p class="distance_50">
          （五）自助银行服务内容
        </p>
        <p class="distance_50">
          客户通过银行柜面或其它途径申请签约自助设备转账等协议并办理相关手续后，即可享受自助银行汇款支付等服务。客户可享受的服务包括：现金存取、发卡签约、账户管理、投资理财、公共事业缴费等。
        </p>
        <p class="distance_50">
          第三条 客户权利和义务
        </p>
        <p class="distance_50">
          （一）权利
        </p>
        <p class="distance_50">
          1.客户自愿申请签约银行电子银行，经银行审核同意后，将有权根据签约项目的类别享受相应的服务。
        </p>
        <p class="distance_50">
          2.客户有权通过银行网站或营业网点查询了解电子银行业务收费标准。
        </p>
        <p class="distance_50">
          3.客户在注册期内有权申请办理手机号码修改、数字证书更新等电子银行变更手续。
        </p>
        <p class="distance_50">
          4.客户在注册期内有权办理电子银行注销手续。
        </p>
        <p class="distance_50">
          5.
          如选择不接受银行对电子银行业务服务范围、章程及服务协议内容的变更，客户有权在银行公告期内至银行网点办理电子银行注销手续。
        </p>
        <p class="distance_50">
          6.客户对银行电子银行服务如有疑问、建议或意见时，可拨打客服电话“95528”或到银行营业网点进行咨询和投诉。
        </p>
        <p class="distance_50">
          （二）义务
        </p>
        <p class="distance_50">
          1.客户办理电子银行业务，应遵守本协议、《上海浦东发展银行电子银行章程》和银行相关业务规定的各项内容。客户到银行营业网点办理电子银行签约、注销、变更等手续，应由本人亲自办理。办理时应根据银行要求提供相关资料，按银行要求填写申请表，并签名确认。客户向银行提供的业务申请表是本协议不可分割的组成部分。客户应保证所填写的申请表与所提供的资料真实、准确、完整，因客户提供信息不真实、不准确或不完整所造成的损失由客户承担。
        </p>
        <p class="distance_50">
          2.客户办理个人网上银行业务应直接登录银行网站（网址：www.spdb.com.cn）；客户通过邮件或其他网站提供的链接地址等其他方式登录所产生的不利后果由客户自行承担。客户办理手机银行（WAP）业务应通过手机直接登录银行手机银行（WAP）网站（网址：http://wap.spdb.com.cn）；客户使用通过移动客户端登录的电子银行，移动客户端软件应从银行网站或设备指定软件下载网站下载。
        </p>
        <p class="distance_50">
          3.客户的客户号、卡/折号、密码、数字证书、接收动态密码的手机是客户进行电子银行交易的重要要素，客户承诺由本人妥善保管，并保证不将该等资料或物品提供或泄露给任何第三方，对因自身提供、泄露、被窃、遗失等原因造成该等资料或物品被他人使用的，该行为视为客户自身完成的行为，客户对该使用行为的后果承担责任。银行执行客户通过电子银行发出的业务指令后，客户不得要求变更或撤销业务指令。
        </p>
        <p class="distance_50">
          4.客户应按照机密的原则设置和保管密码，避免使用生日、电话号码等与本人相关的信息作为密码；不得将本人自设密码、动态密码提供给除法律规定外的任何人；应采取其他合理措施，防止本人密码被窃取。由于密码泄露造成的后果由客户承担。
        </p>
        <p class="distance_50">
          5.客户办理电子银行签约业务，客户应确保向银行提供本人实名登记的手机号。银行向该手机号发送用于安全认证的动态密码短信，客户须确认短信发送编号、交易类型和交易金额等信息与正在进行的交易事项一致，并正确输入收到的动态密码。非银行原因（例如短信网络原因造成迟延、信息丢失，客户提供手机号有误、手机关机、欠费停机、手机号码变更，客户未认真核对信息、未正确操作等原因）导致交易无法完成以及导致的一切损失，银行不承担责任。
        </p>
        <p class="distance_50">
          6.客户发生卡/折丢失、密码泄露、数字证书丢失、接收动态密码的手机丢失、停机或手机号码变更等情况，应及时到银行营业网点办理挂失或手机号码变更等手续，否则可能产生无法正常使用电子银行功能、账户资金安全性降低等各类风险。客户承担到银行营业网点办妥相关手续并生效之前所产生的一切后果。
        </p>
        <p class="distance_50">
          7.客户在使用电子银行服务过程中，所提供的注册信息如需更改，应及时按照银行要求办理有关手续，在上述手续办妥并生效之前所产生的一切后果由客户承担。
        </p>
        <p class="distance_50">
          8.客户应保证办理电子银行业务的账户的支付能力，并严格遵守支付结算业务的相关法律法规及金融监管机构的要求。客户不得以与第三方发生纠纷为由拒绝支付应付银行的各类款项。
        </p>
        <p class="distance_50">
          9.客户不得有意诋毁、损害银行声誉或恶意攻击银行电子银行系统。
        </p>
        <p class="distance_50">
          10.客户办理电子银行业务时，如其使用的服务功能涉及到银行其他业务规定或规则的，须同时遵守相关规定或规则。
        </p>
        <p class="distance_50">
          11.客户长期不使用电子银行，应主动向银行申请办理电子银行的注销手续，否则由其自身承担可能产生的各类风险。
        </p>
        <p class="distance_50">
          12.网银U-Key等账户存取工具和安全认证工具只限客户本人使用，不得出租、出借、出售或转让等，否则客户承担由此产生的一切后果。
        </p>
        <p class="distance_50">
          13.电子银行只限客户本人使用，不得转让、出租、转借、出售，否则由此产生的一切后果由客户承担。客户不得利用电子银行从事任何违反国家法律法规及规章的活动。对可能涉及非法、违规行为的任何交易，银行保留拒绝处理或支付的权利，并有权采取限制或终止服务措施。客户不得使用电子银行参与洗钱、恐怖融资或扩散（大规模杀伤性武器）融资等活动，对可能涉嫌参与上述活动的客户，银行有权对其电子银行采取中止服务、主动锁定和/或销户等措施，并有权终止本协议且不承担任何责任。
        </p>
        <p class="distance_50">
          上述洗钱、恐怖融资或扩散（大规模杀伤性武器）融资等活动，是指联合国安理会、反洗钱金融行动特别工作组、中国、美国、欧盟等国际组织或国家认定的洗钱、恐怖融资或扩散（大规模杀伤性武器）融资行为。
        </p>
        <p class="distance_50">
          第四条 银行的权利和义务
        </p>
        <p class="distance_50">
          （一）权利
        </p>
        <p class="distance_50">
          1.银行有权根据客户资信情况，决定是否受理客户的注册申请。
        </p>
        <p class="distance_50">
          2.银行有权制定电子银行业务收费标准，并在网站或营业网点公布后生效。
        </p>
        <p class="distance_50">
          3.银行有权对电子银行系统进行升级、改造。
        </p>
        <p class="distance_50">
          4.为保护客户个人信息，银行有权主动锁定存在信息泄露风险的客户的电子银行的全部或部分功能。
        </p>
        <p class="distance_50">
          5.客户存在恶意操作、恶意攻击，诋毁、损害银行声誉等情况的，银行有权单方终止对客户提供电子银行服务，并保留追究客户责任的权利。客户利用银行电子银行从事违反国家法律法规或监管机构要求的活动时，银行将有权停止为其办理电子银行业务。
        </p>

        <p class="distance_50">
          6.客户同意银行根据客户的电子银行业务指令办理业务，对所有使用客户号、登录昵称、身份证号码、卡/折号、签约设置的电话或手机号、密码或数字证书等进行的操作均视为客户本人所为，该操作所产生的电子信息记录均为银行处理电子银行业务的有效凭据。
        </p>
        <p class="distance_50">
          7.银行因以下情况没有正确执行客户提交的电子银行业务指令，不承担任何责任：
        </p>
        <p class="distance_50">
          （1）银行接收到的指令信息不明、存在乱码、不完整等。
        </p>
        <p class="distance_50">
          （2）客户账户存款余额或信用额度不足。
        </p>
        <p class="distance_50">
          （3）客户账户内资金被依法冻结或扣划。
        </p>
        <p class="distance_50">
          （4）客户未能按照银行的有关业务规定正确操作。
        </p>
        <p class="distance_50">
          （5）因不可抗力或系统故障、供电故障、通讯故障或网络故障等其他非银行所能控制的事件引起的电子银行业务功能丧失、延迟和数据损坏等造成客户经济损失。
        </p>
        <p class="distance_50">
          8.银行有权通过网站或营业网点公告形式变更电子银行业务的服务范围、章程及服务协议，并设置公告期。
        </p>

        <p class="distance_50">
          9.银行有权根据相关法律法规、监管机构要求、本业务章程及本协议约定等中止或终止为客户提供全部或部分电子银行服务。协议终止或在服务有效期内中止时，银行有权不退回客户已支付的所有费用。
        </p>
        <p class="distance_50">
          （二）义务
        </p>
        <p class="distance_50">
          1.在银行系统正常运行情况下，银行负责及时准确地处理客户发送的电子银行业务指令，并及时向客户提供查询交易记录、资金余额、账户状态等服务。
        </p>
        <p class="distance_50">
          2.银行对于电子银行所使用的相关软件的合法性承担责任。
        </p>
        <p class="distance_50">
          3.银行负责及时为客户办理电子银行签约手续，并按客户注册功能的不同为客户提供相应的电子银行服务。
        </p>

        <p class="distance_50">
          4.银行负责向客户提供电子银行业务咨询服务。
        </p>
        <p class="distance_50">
          5.银行在法律法规许可和客户授权的范围内使用客户的资料和交易记录。银行对客户提供的申请资料和其他信息负有保密的义务，但法律法规或监管机构另有规定的除外。
        </p>
        <p class="distance_50" style="color: red">
          银行收集、使用、储存和共享、转让、公开披露等客户资料及交易记录等信息时须与客户共同遵守《上海浦东发展银行个人客户隐私政策》（详见附件1）
        </p>
        <p class="distance_50">
          6.如客户提供充分证据证明完全由于银行的原因或重大过失造成客户电子银行业务操作的失败或错误，银行应负责赔偿签约客户的经济损失，但任何情况下，银行的赔偿责任应仅限于客户的直接经济损失（即银行手续费），银行的赔偿责任不应包括客户的任何间接损失（例如其预期收益、商业利润等）。
        </p>
        <p class="distance_50">
          第五条 法律适用条款
        </p>

        <p class="distance_50">
          本协议适用中华人民共和国法律（为本协议之目的，在此不包括香港、澳门特别行政区和台湾地区法律）并按其解释。法律无明文规定的，可适用通行的金融惯例。
        </p>
        <p class="distance_50">
          本协议是银行的其他既有协议和约定的补充而非替代文件，如本协议与其他既有协议和约定有冲突，涉及电子银行业务内容的，应以本协议为准。
        </p>
        <p class="distance_50">
          第六条 差错和争议的解决
        </p>
        <p class="distance_50">
          客户发现自身未按规定操作，或由于自身其他原因造成电子银行业务指令未执行、未适当执行、延迟执行的，应及时通过拨打服务热线“
          95528”或到营业网点通知银行。银行应积极调查并告知客户调查结果。
        </p>
        <p class="distance_50">
          双方在履行本协议的过程中，如发生争议，应协商解决。协商不成的，任何一方均可向银行所在地有管辖权的人民法院提起诉讼。双方另有约定的除外。
        </p>
        <p class="distance_50">
          第七条 协议的中止和终止
        </p>
        <p class="distance_50">
          客户电子银行注销手续办理完毕，本协议即为终止。
        </p>
        <p class="distance_50">
          在客户违反本协议规定或其它银行业务规定的情况下，银行有权中止或终止本协议。协议终止并不意味着客户在终止前所发生的未完成交易指令的撤销，也不能消除客户因终止前的交易所应承担的任何法律后果。客户在终止前已发送的交易指令仍有效并应承担其后果，但浦发银行电子银行各项业务规定中另有约定的除外。银行不退还已收取服务费及其他相关费用。
        </p>
        <p
          class="distance_50"
        >
          第八条 协议的效力和生效
        </p>
        <p class="distance_50">
          本协议的任何条款如因任何原因而被确认无效，都不影响本协议其他条款的效力。本协议自客户在线确认同意时生效。
        </p>
        <p class="distance_50">
          第九条 其它
        </p>
        <p class="distance_50">
          上述条款中未尽事项以及相关词语定义适用《上海浦东发展银行电子银行章程》中的规定。
        </p>
        <p class="distance_50">
          本协议附件是本协议不可分割的组成部分，与本协议正文具有同等的法律效力。
        </p>
        <p class="distance_50">
          双方确认，在签署本协议前，已就全部条款进行了详细地说明和讨论，双方对合同的全部条款均无疑义，并对协议涉及的权利义务、责任限制及免责条款的法律含义有了准确无误的理解。客户使用银行电子银行服务即视为客户已了解并完全接受《上海浦东发展银行电子银行章程》。
        </p>
        <br />
        <p class="distance_50">附件1</p>
        <br />
        <p
          class="distance_50"
          style="font-weight: bold; font-size: 16px;text-align:center"
        >
          上海浦东发展银行个人客户隐私政策
        </p>
        <p class="distance_50" style="font-size: 12px;text-align:center">
          本版发布日期：2020年6月22日
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          上海浦东发展银行一直重视并采取措施保护用户（以下简称“您”）的个人信息。我行将根据本《上海浦东发展银行个人客户隐私政策》（以下简称“本政策”）以及其他相关法律文本中的有关约定在中华人民共和国境内（不包括香港、澳门特别行政区及台湾地区）收集、使用、储存及共享、转让、公开披露您的个人信息。此外，我行将通过本政策，说明您如何访问、更正或更新、删除、管理您的个人信息以及行使您的相关权利。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          我行强烈建议您在使用我行的服务前，仔细阅读并完全理解本政策中的全部内容，并自主进行适当的选择。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          本政策适用于浦发银行提供的所有个人客户银行服务，如我行在具体产品或服务中与您就隐私保护政策另有具体约定的，相关约定与本政策将共同构成我行与您之间的隐私政策约定，二者如有不一致之处的，以具体产品或服务中的约定为准。
        </p>
        <p class="distance_50">
          本政策将向您介绍以下内容：
        </p>
        <p class="distance_50">
          1．我行如何收集和使用您的个人信息
        </p>
        <p class="distance_50">
          2．我行如何使用 Cookie和同类技术
        </p>
        <p class="distance_50">
          3．我行如何共享、转让和公开披露您的个人信息
        </p>
        <p class="distance_50">
          4．我行如何存储和保护您的个人信息
        </p>
        <p class="distance_50">
          5．您如何管理您的个人信息
        </p>
        <p class="distance_50">
          6．我行如何处理未成年人的信息
        </p>
        <p class="distance_50">
          7．本政策如何更新
        </p>
        <p class="distance_50">
          8．如何联系我行
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          一、我行如何收集和使用您的个人信息
        </p>
        <p class="distance_50">
          个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。
        </p>
        <p class="distance_50">
          个人信息包括姓名、出生日期、身份证件号码、个人生物识别信息、通信通讯联系方式、住址、账户信息、交易信息、财产信息、信用信息、消费偏好、行踪轨迹、联网核查信息等。
        </p>

        <p class="distance_50" style="color:#000;font-weight:bold">
          （一）我行收集个人信息的原则
        </p>
        <p class="distance_50">
          我行收集您的个人信息遵循合法、正当、必要的原则。我行按照法律法规要求以及业务需要收集您的个人信息，不会收集与业务无关的信息或采取不正当方式收集信息。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （二）我行收集您的个人信息的目的
        </p>
        <p class="distance_50">
          我行收集您的个人信息，目的在于依法合规地为您提供优质的产品（或服务），该等信息对于充分履行您和我行之间的合约很有必要，并使得我行能够遵守相关法律，具体包括：
        </p>
        <p class="distance_50">
          1.为保护您的账户安全，对您的身份进行识别、验证等；
        </p>
        <p class="distance_50">
          2.为评估您的履约能力及状况，用于业务准入和风险防控；
        </p>

        <p class="distance_50">
          3.为您提供产品（或服务）所必须（包括但不限于为购买理财类产品进行的风险承受能力评估问卷、为评估您的风险偏好，合理提供产品推介和投资建议等）；
        </p>
        <p class="distance_50">
          4.为保护您的资金安全；
        </p>
        <p class="distance_50">
          5.为改善产品（或服务）、提升您的体验；
        </p>
        <p class="distance_50">
          6.为履行法定义务（如反洗钱义务等）；
        </p>
        <p class="distance_50">
          7.经您许可的其他用途。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （三）我行收集您的个人信息的方式
        </p>
        <p class="distance_50">
          为向您提供服务并确保您的电子银行服务（网上银行服务、手机银行服务、短信服务、微信银行服务、电话银行服务、直销银行服务等）安全，在您使用电子银行服务过程中，我行会收集您在使用服务过程中主动输入或因使用服务而产生的信息：
        </p>
        <p class="distance_50">
          1.当您开通电子银行服务时，依据法律法规及监管要求，我行会收集您的
          <span style="color:#000;font-weight:bold"
            >个人基本资料、身份信息、财产信息、通信信息、生物识别信息、手机号码信息，</span
          >
          以帮助您完成电子银行注册，如果您拒绝提供这些信息，您可能无法开通电子银行或无法正常使用我行的服务。
        </p>
        <p class="distance_50">
          2.当您使用浦发银行电子银行服务时，例如在下列情形中，您需要向我行提供或授权我行收集相应服务所需的用户信息。如您拒绝提供，您将无法使用相应功能或服务。
        </p>
        <p class="distance_50">
          （1） 当您注册浦发银行手机银行时，我行会收集您的
          <span style="color:#000;font-weight:bold"
            >手机号码、头像、昵称、身份证件信息、银行卡信息，</span
          >
          并验证您的客户查询密码、以及银行卡交易密码，在需要短信验证码的环节，需要读取验证码短信内容，以协助您进行验证码填写。如您拒绝通讯信息授权，我行手机银行将不读取短信内容，我行不保存短信内容。
        </p>
        <p class="distance_50">
          （2）如您在手机银行中选择通过指纹/FACE
          ID、声纹、刷脸功能进行登录、转账、支付、身份认证，需向我行提供您的<span
            style="color:#000;font-weight:bold"
            >指纹/FACE ID、声音、人脸图像信息。</span
          >我行不会采集您的指纹/FACE ID，您的指纹/FACE
          ID仅保存在您授权采集指纹的设备上。经您授权后，我行将采集您的声纹信息、人脸信息，将加密存储于我行信息系统后台数据库中。如您不提供上述信息，我行将无法向您提供需完成指纹/FACE
          ID、声纹、人脸认证后方可使用的产品或服务。您可以通过“首页-全部-安全”或在首页搜索关键词“认证”开启或关闭此功能。
        </p>
        <p class="distance_50">
          （3）当您使用微信、支付宝授权登录功能时，我行需要您提供<span
            style="color:#000;font-weight:bold"
            >微信、支付宝账号的昵称与头像信息。</span
          >您可以通过“首页-全部-第三方账号管理”取消授权及相应账号信息绑定。
        </p>
        <p class="distance_50">
          （4）当您使用我行及时语服务时，我行会收集您的<span style="color:#000;font-weight:bold"
            >账户信息和交易信息，手机号/邮箱地址/微信昵称/支付宝昵称，</span
          >以便及时向您发送账户资金变动及相关交易通知；我行也可能向我行的合作伙伴收集其合法留存并经您授权可以共享使用的信息，以便为您提供相应消息通知等服务。
        </p>
        <p class="distance_50">
          （5） 当您使用网点服务等基于地理位置的功能时，我行会收集您的<span
            style="color:#000;font-weight:bold"
            >位置信息，</span
          >目的是为了向您提供所在位置的相应服务。如您拒绝提供该信息，您将无法使用上述功能，但这不影响您正常使用手机银行的其他功能。
        </p>
        <p class="distance_50">
          （6）当您使用手机号转账等涉及通讯录的功能时，<span style="color:#000;font-weight:bold"
            >我行仅获取您从通讯录中点选的联系人信息，</span
          >并进行加密传输以防止恶意截取。上述信息属于个人敏感信息。如您不需使用上述功能，可以不提供该信息，不影响您正常使用其他功能。
        </p>
        <p class="distance_50">
          （7）当您使用转账汇款、小浦支付、扫码支付等收付款功能时，您需要提供<span
            style="color:#000;font-weight:bold"
            >收款方的姓名、银行卡号/账户等信息，并可能需要提供您的姓名、手机号、证件类型、证件号码等信息，</span
          >以便验证身份使用上述支付功能。此外，我行还会收集您的相关收付款交易记录以便您查询。具体事项按您开通我行手机银行时同意签署的《上海浦东发展银行电子银行个人客户服务协议》执行。上述信息属于敏感信息，如您拒绝提供，将无法使用上述功能，但不影响您使用手机银行其他功能。
        </p>
        <p class="distance_50">
          （8）当您使用搜索服务时，我行会收集您的<span style="color:#000;font-weight:bold"
            >搜索关键词信息。</span
          >当搜索关键词信息无法单独识别您的个人身份时，该信息不属于您的用户信息，我行可以对其加以其他目的使用；当搜索关键词信息与您的其他信息结合可以识别您的个人身份时，我行将在结合期间将您的搜索关键词信息作为您的用户信息，对其加以保护处理。
        </p>
        <p class="distance_50">
          （9）当您使用我行提供的实名认证服务时，我行可能需要您提供您的<span
            style="color:#000;font-weight:bold"
            >姓名、证件类型、证件号码、银行卡号、设备信息、指纹/FACE
            ID信息、刷脸认证</span
          >等信息，并可能通过验证手机号/查询密码、银行卡号/卡密码、短信验证码等方式对有关信息进行有效性核验。若您不提供上述信息，我行将无法向您提供须完成实名认证后方可使用的产品或服务。
        </p>
        <p class="distance_50">
          （10）当您使用内嵌的购物及生活服务等功能时，您需要在订单页面填写<span
            style="color:#000;font-weight:bold"
            >收货人姓名、收货地址及手机号码等信息；</span
          >您在预定电影票、出行、酒店等服务时，还可能需要根据国家法律法规及监管要求或服务提供方（包括票务销售方、酒店、旅行社及其授权的代理方、基础电信运营商、移动转售运营商等）的要求提供<span
            style="color:#000;font-weight:bold"
            >您的实名信息，</span
          >这些实名信息可能包括您的身份信息（比如身份证、军官证、护照、驾驶证等载明您身份的证件）、您本人的照片或视频、联系电话等。这些订单中将可能包含<span
            style="color:#000;font-weight:bold"
            >您的行程、酒店地址</span
          >等信息。上述所有信息构成您的订单信息，我行将使用您的<span
            style="color:#000;font-weight:bold"
            >订单信息</span
          >来进行您的身份核验、确定交易、支付结算、完成配送、为您查询订单以及提供客服咨询与售后服务；我行还会使用您的订单信息来判断您的交易是否存在异常以保护您的交易安全。
        </p>
        <p class="distance_50">
          下单后，您可以选择使用浦发卡支付或他行卡支付。当您下单并选择货到付款或在线完成支付后，商户和第三方配送公司将为您完成订单的交付。您在此同意，商户和第三方配送公司、售后服务等可以使用您的订单信息以为您提供商品或服务。
        </p>
        <p class="distance_50">
          我行的电话客服和售后功能会使用您的<span style="color:#000;font-weight:bold"
            >账号信息和订单信息。</span
          >为保证您的账号安全，我行的呼叫中心客服和在线客服会使用您的账号信息与您核验身份。当您需要我行提供与您订单信息相关的客服与售后服务时，我行将会查询您的<span
            style="color:#000;font-weight:bold"
            >订单信息。</span
          >您有可能会在与我行的客服人员沟通时，提供除上述信息外的其他信息，例如：当您要求我行变更配送地址、联系人或联系电话时。
        </p>
        <p class="distance_50">
          3.当您使用电子银行服务时，为了维护服务的正常运行，优化我行的服务体验及保障您的账号安全，我行会收集以下基础信息，包括您的<span
            style="color:#000;font-weight:bold"
            >设备型号、操作系统、唯一设备标识符、手机银行软件版本号、登录IP地址、接入网络的方式、类型和状态、网络质量数据、设备加速器（如重力感应设备）、操作日志、服务日志信息（如您在手机银行搜索、查看的信息、服务故障信息等），</span
          >这些信息是为您提供服务必须收集的基础信息，以保障您正常使用我行的服务。
        </p>
        <p class="distance_50">
          在特定使用场景下，我行会使用具有相应业务资质及服务能力的第三方服务商提供的软件开发工具包（简称“SDK”）来为您提供服务，<span
            style="color:#000;font-weight:bold"
            >此时需要通过SDK来收集您的必要信息，</span
          >对应使用场景详见附件。
        </p>
        <p class="distance_50">
          4.为向您提供更加准确、个性和便捷的服务，提升服务体验、改进服务质量，或为防范风险，我行会收集您<span
            style="color:#000;font-weight:bold"
            >反馈意见建议或举报时提供的信息，</span
          >收集您参与问卷调查时向我行反馈的信息，收集您使用电子银行功能或服务的类别、方式和操作信息，及您在我行的用户信息，我行会对这些信息进行统计、分析，并会根据上述信息向您提供相应服务或产品。
        </p>
        <p class="distance_50">
          5.当您在电子银行中使用第三方提供的服务时，第三方可能会获取<span
            style="color:#000;font-weight:bold"
            >您的昵称、头像、位置、姓名、证件类型、证件号码、手机号码信息；</span
          >在经过您的明示同意后，第三方可获取您的以上信息；对于您在使用第三方提供的服务时主动提供给第三方的相关信息，我行将视为您允许该第三方获取上述此类信息；对于您在使用该第三方服务时产生的信息，应由您与该第三方依法约定上述信息的收集和使用事项。如您拒绝第三方在提供服务时收集、使用或者传递上述信息，将可能会导致您无法在电子银行中使用第三方的相应服务，但这不影响您使用电子银行的其他功能。
        </p>
        <p class="distance_50">
          6.以下情形中，您可选择是否授权我行收集、使用您的个人信息：
        </p>
        <p class="distance_50">
          （1）设备状态，用于确定设备识别码，以保证账户登录的安全性。拒绝授权后，将无法正常使用浦发银行手机银行App。
        </p>
        <p class="distance_50">
          （2）存储权限，用于缓存您在使用APP过程中产生的文本、图像、视频等内容。拒绝授权后，将无法正常使用浦发银行手机银行App。
        </p>
        <p class="distance_50">
          （3）摄像头，用于如识别二维码、人脸识别、设置头像、拍摄证件信息用途，在人脸识别登录/转账/支付/认证、扫一扫、AR扫、头像设置、证件信息上传开通场景中使用。拒绝授权后，上述功能将无法使用。我行将获取的人脸等数据，加密后存储于系统后台数据库中。
        </p>
        <p class="distance_50">
          （4）相册，访问相册主要用于上传开户证件、设置您的头像、备注交易信息，保存电子回单等。我行获得的图片信息，加密后存储于数据库中。拒绝授权后，上述功能将无法使用。
        </p>
        <p class="distance_50">
          （5）麦克风，用于U-Key、声纹识别、录音、语音银行等用途，且仅在客户使用U-Key认证、声纹登录/转账/支付、语音银行场景中运用该权限。拒绝授权后，上述功能将无法使用。我行采集的声纹数据及录音数据，加密后存储于系统后台数据库中。
        </p>
        <p class="distance_50">
          （6）手机通讯录，在转账、支付，或参与个人活动过程中，用于协助您通过通讯录快速选取电话号码，无需您手动输入。拒绝授权后，向手机号转账、短信通知功能仍可以使用，但需要手工输入手机号码。手机银行仅读取并记录指定电话号码，不读取客户全量通讯录，我行后台系统不存储通讯录。
        </p>
        <p class="distance_50">
          （7）手机短信，在需要短信验证码的环节需要读取验证码短信内容协助您进行验证码填写。如您拒绝通讯信息（短信）授权，我行手机银行将不读取短信内容，系统后台不保存短信内容。
        </p>
        <p class="distance_50">
          （8）地理位置，获取您所在地理位置，主要用于电子银行交易风控、网点预约、ATM位置查询等服务。系统后台保存您交易时的位置信息。拒绝授权后，手机银行相关功能无法使用。
        </p>
        <p class="distance_50">
          （9）电话权限，用于使用手机银行时，拨打电话联系客服、线下网点等用途，且仅在客户使用场景中运用该权限。拒绝授权后，手机银行相关功能无法使用。
        </p>
        <p class="distance_50">
          （10）SIRI，用于通过SIRI办理登录、查询等用途，且仅在客户使用场景中运用该权限。拒绝授权后，手机银行相关功能无法使用。
        </p>
        <p class="distance_50">
          （11）蓝牙，用于U-Key验证等用途，且仅在客户使用场景中运用该权限。拒绝授权后，手机银行相关功能无法使用。
        </p>
        <p class="distance_50">
          （12）网络通讯，用于与服务端进行通讯。拒绝授权后，手机银行所有功能无法使用。系统后台保存客户交易时所使用设备的网络信息，包括IP、端口等信息。
        </p>
        <p class="distance_50">
          上述功能可能需要您在您的设备中向我行开启您的相机（摄像头）、地理位置（位置信息）、麦克风等访问权限，以实现这些功能所涉及的信息的收集和使用。请您注意，您开启这些权限即代表您授权我行可以收集和使用这些信息来实现上述功能，如您取消了这些授权，则我行将不再继续收集和使用您的这些信息，也无法为您提供上述与这些授权所对应的功能。
        </p>
        <p class="distance_50">
          如在上述情形之外收集或使用您的信息，我行会事先征求您的同意，并向您充分告知信息收集和使用的目的、方式和范围。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （四）我行如何使用您的个人信息
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          1.在我行向您提供金融产品或服务，以及改进这些产品或服务时使用。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          2.在我行向您提供金融服务期间，您授权我行持续收集和使用您的相关个人信息。在您注销服务或取消授权时，我行将停止收集及使用您的相关个人信息，但我行会根据法律法规及监管的要求在业务资料归档、审计、监管协查等领域继续使用此前收集的您的相关个人信息。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          3.为提升您的体验，或为防范风险，我行会对您服务使用情况的相关信息进行统计分析、加工，但这些信息不会包含您的任何身份识别信息。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          4.因反洗钱和反恐怖融资需要，授权我行向且仅向涉及办理被调查业务的第三方金融机构提供您在我行的相关资料。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          5.将您的个人信息用于法律允许的其它用途。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          6.当我行要将您的用户信息，用于本政策载明的收集目的、用途或合理相关范围以外的其他用途时，我行将在使用前再次征得您的同意
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          7.根据相关法律法规、监管要求及国家标准，以下情形中，我行可能会收集、使用您的相关个人信息而无需另行征求您的授权同意：
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （1）与国家安全、国防安全直接相关的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （2）与公共安全、公共卫生、重大公共利益直接相关的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （3）与犯罪侦查、起诉、审判和判决执行等直接相关的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （5）所收集的个人信息是您自行向社会公众公开的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （7）根据您要求签订和履行合同所必需的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （8）用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （9）出于公共利益开展统计或学术研究所必需，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （10）法律法规及监管要求规定的其他情形。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          二、我行如何使用Cookie和同类技术
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （一）Cookie
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          为确保网站正常运转，我行会在您的计算机或移动设备上存储名为Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。借助于Cookie，网站能够存储您的偏好或者您使用的商品或服务等数据。我行不会将Cookie用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除
          Cookie。有关详情，请参见
          AboutCookies.org。您可以清除计算机上保存的所有
          Cookie，大部分网络浏览器都设有阻止 Cookie
          的功能。但如果您这么做，则需要在每一次访问我行的网站时亲自更改用户设置。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （二）网站信标和像素标签
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          除 Cookie
          外，我行还会在网站上使用网站信标和像素标签等其他同类技术。例如，我行向您发送的电子邮件可能含有链接至我行网站内容的点击
          URL。如果您点击该链接，我行则会跟踪此次点击，帮助我行了解您的产品或服务偏好并改善客户服务。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我行能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时退订。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （三）Do Not Track（请勿追踪）
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          很多网络浏览器均设有 Do Not Track 功能，该功能可向网站发布 Do Not
          Track
          请求。目前，主要互联网标准组织尚未设立相关政策来规定网站应如何应对此类请求。但如果您的浏览器启用了
          Do Not Track，那么我行的所有网站都会尊重您的选择。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （四）日志与位置信息
        </p>
        <p class="distance_50">
          为提升您的体验及保护您的资金安全之目的，我行可能会自动收集日志信息和位置信息。我行不会将这些信息用于本政策撰述目的之外的任何用途。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          日志信息包括：
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          1.设备或软件信息，例如您的移动设备、网页浏览器或您用于接收我行服务的其他程序所提供的配置信息、IP地址、无线网络接入信息，以及您的移动设备所用的版本和设备识别码；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          2.您在设备上曾使用的移动应用（APP）和其他软件的信息。位置信息指您开启设备定位功能并使用我行基于位置提供的相关服务时，我行收集的有关您位置的信息。您可以通过关闭定位功能随时停止我行对您的地理位置信息的收集。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          三、我行如何共享、转让和公开披露您的个人信息
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （一）共享
        </p>
        <p class="distance_50">
          除以下情况外，我行不会主动与其他任何公司、组织和个人分享您的个人信息：
        </p>
        <p class="distance_50">
          1.政府、监管部门或司法机关要求共享等法律法规规定的情况下，我行将向其共享您的个人信息；
        </p>
        <p class="distance_50">
          2.事先获得您的明确同意。如因业务需要对外共享您的个人信息时，我们会向您告知共享个人信息的目的、范围和数据接收方身份，并征得您的授权或同意。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （二）转让
        </p>
        <p class="distance_50">
          我行不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
        </p>
        <p class="distance_50">
          1．在获取明确同意的情况下转让：获得您的明确同意或授权后，我行会向其他方转让您的个人信息；
        </p>

        <p class="distance_50">
          2．根据法律法规规定或强制性的行政与司法要求；
        </p>
        <p class="distance_50">
          3．根据法律法规和商业惯例，在合并、收购、资产转让、兼并、重组或破产清算等类似交易中，如涉及到个人信息转让，我行会要求新的持有您个人信息的公司、组织继续受本徇私政策的约束，否则我行将要求该公司、组织重新向您征求授权同意。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （三）公开披露
        </p>
        <p class="distance_50">我行仅会在以下情况下，公开披露您的个人信息：</p>
        <p class="distance_50">1．获得您明确同意或授权后；</p>
        <p class="distance_50">
          2．政府、监管部门或司法机关要求披露等法律法规规定的情况下，我行将公开披露您的个人信息，且无需征得您的同意。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （四）征得授权同意的例外
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          根据相关法律法规及监管要求、国家标准，以下情形中，我行可能会共享、转让、公开披露用户信息无需事先征得您授权同意：
        </p>
         <p class="distance_50" style="color:#000;font-weight:bold">
          （1）与履行国家法律法规及行业主管部门有关规定的义务相关的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （2）与国家安全、国防安全直接相关的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （3）与公共安全、公共卫生、重大公共利益直接相关的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （4）与犯罪侦查、起诉、审批和判决执行等直接相关的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （5）出于维护您或其他个人的生命、财产、声誉等重大合法权益但又很难得到本人同意的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （6）您自行向社会公众公开的个人信息；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （7）从合法公开披露的信息中收集的用户信息，如合法的新闻报道、政府信息公开等渠道。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （8）用于维护所提供的金融产品或服务的安全稳定运行所必需的，例如识别、处置金融产品或服务中的欺诈或被盗用等。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          四、我行如何存储和保护您的个人信息
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （一）存储
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          按照相关法律法规规定，我行将中华人民共和国境内（不包括香港、澳门特别行政区及台湾地区）提供服务过程中收集和产生的您的个人信息存储在中华人民共和国境内（不包括香港、澳门特别行政区及台湾地区）。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          我行仅在为您提供服务及相关服务之目的所必需的期限内和法律法规及监管规定的时限内留存您的个人信息。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          如果终止服务，我行将及时停止收集您个人信息，并对所持有的您的个人信息进行删除或匿名化处理，法律法规或监管机构对个人信息存储时间另有规定的除外。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （二）保护
        </p>
        <p class="distance_50">
          1.我行已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权的访问、公开披露、使用、修改、损坏或丢失。我行会采取一切合理可行的措施，保护您的个人信息。例如：我行会使用加密技术确保数据的保密性；我行会使用受信赖的保护机制防止数据遭到恶意攻击；我行会部署访问控制机制，确保只有授权人员才可访问个人信息；以及我行会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
        </p>
        <p class="distance_50">
          2.我们会采取一切合理可行的措施，确保不收集无关的个人信息。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          3.请您理解，由于技术水平局限以及可能存在的恶意攻击，有可能出现我行无法合理预见、防范、避免、控制的意外情况。互联网并非绝对安全的环境，请使用复杂密码，协助我行保证您的账号安全。
        </p>
        <p class="distance_50">
          4.如发生个人信息安全事件，我行将按照法律法规要求，及时将事件相关情况以邮件或信函或电话或推送通知等方式告知您，或采取合理、有效的方式发布公告。同时，我行还将依据监管规定，主动上报个人信息安全事件处置情况。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          五、您如何管理您的个人信息
        </p>
        <p class="distance_50">
          按照中国相关的法规和监管规定，我行保障您对自己的个人信息行使以下权利：
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （一）访问、更正及更新您的个人信息
        </p>
        <p class="distance_50">
          您有权通过我行网上银行、手机银行、微信银行、电话银行等渠道的个人信息修改功能服务访问及更正、更新您的个人信息，法律法规规定的例外情况除外。您有责任及时更新您的个人信息。在您修改个人信息之前，我行会验证您的身份。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （二）删除您的个人信息
        </p>
        <p class="distance_50">
          在以下情形中，您可以向我行提出删除个人信息的请求：
        </p>
        <p class="distance_50">1．如果我行处理您个人信息的行为违反法律法规；</p>
        <p class="distance_50">
          2．如果我行收集、使用您的个人信息，却未征得您的同意；
        </p>
        <p class="distance_50">
          3．如果我行处理个人信息的行为违反了与您的约定；请您注意，我行电子银行签约用户仅在手机设备中删除手机银行App时，我行不会解除您的电子银行签约，有关您手机银行的一切信息不会删除。
        </p>
        <p class="distance_50">
          4．如果您终止我行提供的账户服务和电子银行服务；
        </p>
        <p class="distance_50">5．如果我行不再为您提供服务。</p>
        <p class="distance_50">
          如我们决定响应您的删除请求，我们还将同时通知从我行获得您个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。
        </p>
        <p class="distance_50">
          当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （三）注销用户
        </p>
        <p class="distance_50">
          如您为我行手机银行用户，您可通过营业网点、手机银行等渠道注销您的手机银行签约账户。您注销手机银行的行为是不可逆行为，一旦注销，我行将不再通过手机银行收集您的个人信息，并将删除有关您手机银行的信息，法律法规或监管机构对个人信息存储时间另有规定的除外。您可以自主选择卸载或停止使用浦发银行手机银行客户端，以阻止我行获取您的个人信息。请您注意，我行手机银行签约绑定客户仅在手机设备中删除手机银行客户端时，我行不会注销您的手机银行账户，有关您手机银行账户的一切信息不会删除。您仍需要注销您的手机银行签约账户方能达到以上目的。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （四）改变您的授权范围
        </p>
        <p class="distance_50">
          您有权决定是否继续对您个人信息采集、使用等进行授权，您可以通过浦发银行手机银行首页搜索“安全”，进入安全页面，关闭本隐私政策的授权，关闭后我行将不再继续采集、使用、您相应的个人信息，请您理解如您取消授权，我行将无法为您提供电子渠道服务（含浦发手机银行、网上银行）服务，也不再继续处理您相应的个人信息（如您已就具体产品或服务与我行另行签署授权的除外），但您取消本隐私政策授权的决定，不会影响我行此前基于您授权已开展的个人信息处理。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （五）获取您的个人信息副本
        </p>
        <p class="distance_50">
          您有权获取您的个人信息副本。如果您需要获取我行收集的您的个人信息副本，您可通过联系附近的浦发营业网点，在符合相关法律法规且技术可行的前提下，我行将根据您的要求向您提供您的个人信息副本。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （六）响应您的上述请求
        </p>
        <p class="distance_50">
          为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我行可能会先要求您验证自己的身份，然后再处理您的请求。请您理解，对于某些无端重复、需要过多技术手段、给他人合法权益带来风险或者非常不切实际的请求，我行可能会予以拒绝。
        </p>
        <p class="distance_50">
          在以下情形中，按照法律法规要求，我行将无法响应您的请求：
        </p>
        <p class="distance_50">1.与国家安全、国防安全直接相关的；</p>
        <p class="distance_50">
          2.与公共安全、公共卫生、重大公共利益直接相关的；
        </p>
        <p class="distance_50">
          3.与犯罪侦查、起诉、审判和判决执行等直接相关的；
        </p>
        <p class="distance_50">4.有充分证据表明您存在主观恶意或滥用权利的；</p>
        <p class="distance_50">
          5.响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的。
        </p>
        <p class="distance_50">6.涉及商业秘密的。</p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          六、我行如何处理未成年人的信息
        </p>

        <p class="distance_50" style="color:#000;font-weight:bold">
          我行的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，未成年人不得创建自己的用户账户。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          对于经父母同意而收集未成年个人信息的情况，我行只会在法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          七、本政策如何更新
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          根据国家法律法规变化及服务运营需要，我行可能会对本政策及相关规则进行修改，修改后的内容会通过我行网上银行、手机银行等渠道予以公告，并取代此前相关内容。在公告期内，您可以选择是否继续同意授权，若您不愿接受公告内容，应在公告内容正式实施前取消授权。如您继续使用我行服务，即表示您已充分阅读、理解并接受更新后的政策并愿意接受更新后的政策约束。未经您的明确同意，我行不会削减您按照本隐私政策所应享有的权利。您应不时关注相关公告、提示信息及协议、规则等相关内容的变动。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          八、如何联系我行
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          如您对本隐私政策有任何疑问、意见或建议，请联系我行客服热线：95528。受理您的问题后，我行会及时处理，将在15个工作日内给予答复。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          公司名称：上海浦东发展银行股份有限公司
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          注册地址：上海市中山东一路12号
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          邮箱地址： dcsc02@spdb.com.cn
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          请您在同意之前仔细阅读本隐私政策，确保对其内容含义及相应法律后果已全部知晓并充分理解。您选择“同意”即视为您接受并签署本隐私政策授权，我行将按照相关法律法规及本政策合法使用和保护您的个人信息。
        </p>


        <p class="distance_50">附件：</p>
        <p style=" font-weight: bold; font-size: 16px;text-align:center">
          浦发银行SDK使用场景列表
        </p>
        <p class="distance_50">
          当您使用浦发银行App的功能或服务时，在特定使用场景下，App会使用具有相应业务资质及服务能力的第三方服务商提供的应用软件开发工具包（简称“SDK”）来为您提供服务，此时需要通过SDK来收集您的必要信息。以下表格包含了您在使用APP的过程中可能触及到的SDK产品，供您查询了解。
        </p>
        <p class="distance_50">
          我们将尽全力保护您的个人信息和合法权益，再次感谢您的信任！
        </p>
        <table border="1" style="border-collapse: collapse;" class="table">
          <thead>
            <tr>
              <th>SDK名称</th>
              <th>采集数据</th>
              <th>提供服务/功能</th>
              <th>所属公司</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                个推SDK（包括小米推送SDK、华为推送SDK、OPPO推送SDK、VIVO推送SDK、魅族推送SDK）
              </td>
              <td>
                手机终端标识信息、手机厂商、手机型号、系统类型、系统版本、电话状态信息
              </td>
              <td>App消息推送功能，推送服务及账户变动通知</td>
              <td>浙江每日互动网络科技有限公司</td>
            </tr>
            <tr>
              <td>依图SDK</td>
              <td>手机终端标识信息，获取摄像头、麦克风权限</td>
              <td>人脸识别、活体检测</td>
              <td>上海依图网络科技有限公司</td>
            </tr>
            <tr>
              <td>飞天Ukey SDK</td>
              <td>手机电话状态信息，麦克风权限</td>
              <td>Ukey安全认证功能</td>
              <td>飞天诚信科技股份有限公司</td>
            </tr>
            <tr>
              <td>天地融Ukey SDK</td>
              <td>手机电话状态信息，麦克风权限</td>
              <td>Ukey安全认证功能</td>
              <td>天地融科技股份有限公司</td>
            </tr>
            <tr>
              <td>银联HCE SDK</td>
              <td>手机终端标识信息</td>
              <td>银联HCE、无卡支付功能</td>
              <td>中国银联</td>
            </tr>
            <tr>
              <td>腾讯设备指纹SDK</td>
              <td>手机终端标识信息、位置信息、电话状态信息</td>
              <td>网络贷款申请过程中的反欺诈识别功能</td>
              <td>腾讯公司</td>
            </tr>
            <tr>
              <td>大智慧SDK</td>
              <td>手机终端标识信息、电话状态信息、麦克风权限</td>
              <td>提供贵金属、商品、外汇行情服务</td>
              <td>大智慧</td>
            </tr>
            <tr>
              <td>中国金融认证中心（CFCA）SDK</td>
              <td>
                获取客户数据： 姓名、证件类型、证件号码、电话号码 设备类数据：
                手机终端标识信息、手机厂商、手机型号、系统类型、系统版本、网络类型、IP、MAC地址、电话状态；
              </td>
              <td>
                向CFCA申请专属于用户本人的数字证书，保障手机银行交易安全。
              </td>
              <td>中国金融认证中心（CFCA）</td>
            </tr>
            <tr>
              <td>科大讯飞语音SDK</td>
              <td>
                麦克风权限
              </td>
              <td>
                语音银行中的语音识别功能
              </td>
              <td>科大讯飞股份有限公司</td>
            </tr>
            <tr>
              <td>合合信息OCR SDK</td>
              <td>
                摄像头权限
              </td>
              <td>
                卡号、身份证件识别服务中的拍照、图像识别功能
              </td>
              <td>上海合合信息技术发展有限公司</td>
            </tr>
            <tr>
              <td>视+AR SDK</td>
              <td>
                摄像头权限
              </td>
              <td>
                AR识别
              </td>
              <td>视辰信息科技（上海）有限公司</td>
            </tr>
            <tr>
              <td>极验SDK</td>
              <td>
                手机终端标识信息、手机厂商、手机型号、设备名称、系统语言、系统类型、系统版本、网络类型、IP地址
              </td>
              <td>
                验证码校验
              </td>
              <td>武汉极意网络科技有限公司</td>
            </tr>
            <tr>
              <td>电子社保SDK</td>
              <td>
                获取客户数据：姓名、证件类型、证件号码、电话号码、实体社保卡号（二级）
                设备类数据：IOS:UUID、手机型号、系统版本；安卓：安卓ID、手机型号、系统版本
              </td>
              <td>
                访问全国社保卡平台
              </td>
              <td>金保信社保卡科技有限公司</td>
            </tr>
            <tr>
              <td>微通SDK</td>
              <td>
                无
              </td>
              <td>
                密码键盘
              </td>
              <td>北京微通新成公司</td>
            </tr>
          </tbody>
        </table>

        <br/>
        <br/>


        <p style=" font-weight: bold; font-size: 16px;text-align:center">
          上海浦东发展银行个人电子账户产品服务协议
        </p>
        <p class="distance_50">
          个人电子账户产品申请人（以下简称“客户”）自愿申请使用上海浦东发展银行（以下简称“浦发银行”）提供的个人电子账户产品（以下简称“电子账户”）服务，为明确双方的权利和义务，维护双方的合法权益，就电子账户服务相关事宜达成本协议，以资共同遵守。
        </p>
        <p class="distance_50">
          一、定义
        </p>
        <p class="distance_50">
          1.1
          “电子账户”指浦发银行接受客户申请，通过浦发银行指定渠道为客户开立的,可依托浦发银行网络渠道或第三方合作渠道向客户提供相关金融服务的专用服务账户，含电子账户（Ⅱ类）与电子账户（Ⅲ类）。
        </p>
        <p class="distance_50">
          1.2
          绑定账户：客户申请开立电子账户时，须将电子账户与客户本人已开立的同名银行卡建立绑定关系，电子账户（Ⅱ类）须绑定同名I类银行卡或信用卡，电子账户（Ⅲ类）须绑定同名I类银行卡，经浦发银行对客户留存的身份证件信息、手机号码及绑定账户等内容核验无误后方可办理开户。
        </p>
        <p class="distance_50">
          二、申请
        </p>
        <p class="distance_50">
          2.1
          客户自愿申请开立电子账户，知悉、理解并愿意遵守《上海浦东发展银行个人电子账户产品章程》（以下简称“《章程》”）的相关条款，履行本协议，并遵守国家有关金融法律法规、政策及浦发银行电子账户服务有关规定。
        </p>
        <p class="distance_50">
          2.2
          申请开立电子账户的客户应当为具备完全民事行为能力的中华人民共和国公民。
        </p>
        <p class="distance_50">
          2.3
          客户向浦发银行提供的资料应当合法、真实、有效、完整、准确，且发生变更时应当及时告知开户机构，否则由此产生的一切损失由客户承担。客户同意并授权浦发银行有权向任何有关方面了解客户的有关资料，有权索取、留存和使用客户的个人资料，并有权决定是否同意客户申请。浦发银行收集、使用、储存和共享、转让、公开披露等客户信息时须与客户共同遵守《上海浦东发展银行个人客户隐私政策》（详见附件1）。客户知晓并理解该等资料、信息及信用状况被提供和使用可能会造成对客户不利的后果和风险，这些不利的后果和风险包括但不限于对客户的信用评级（评分）、信用报告等结果可能产生不利影响。
        </p>
        <p class="distance_50">
          2.4
          客户申请电子账户时提交的合法有效居民身份证应当与绑定账户所使用的居民身份证一致，提交的手机号应当与绑定账户的预留手机号一致。
        </p>
        <p class="distance_50">
          三、服务内容
        </p>
        <p class="distance_50">
          3.1
          浦发银行为客户提供网上银行、手机银行等服务，客户使用和操作上述服务时应遵守浦发银行相关服务的规定。
        </p>
        <p class="distance_50">
          3.2客户通过电子账户向商家进行的支付，均构成一项有效的电子账户交易，浦发银行将在客户的电子账户中就该等交易进行借记。客户不得以与商户或其他第三方的纠纷为由对浦发银行划付该项款项提出异议。因不可抗力或非因浦发银行过错引起的系统、供电、通讯或网络故障等各项原因导致客户使用电子账户交易失败而造成的损失，浦发银行不承担任何责任。浦发银行视情况协助客户解决问题或提供必要的帮助。
        </p>
        <p class="distance_50">
          3.3
          客户可通过浦发银行营业网点、网上银行、手机银行等渠道和方式了解其电子账户的账务变动情况。电子账户不提供纸质对账单服务。客户对交易账务变动情况有异议的，须于交易发生后60天内向浦发银行提出查询或更正申请。否则视为客户同意并接受所有账务情况的变动内容。
        </p>
        <p class="distance_50">
          四、电子账户的禁止使用
        </p>
        <p class="distance_50">
          电子账户仅可用于合法交易。客户不得使用电子账户进行任何违反法律、法规及规章的交易，否则由此产生的一切后果由客户自行承担。对可能违反法律、法规及规章的任何交易，浦发银行有权随时停止向客户提供相应服务、中止客户使用电子账户、主动锁定和/或注销电子账户。
        </p>
        <p class="distance_50">
          对自开户之日起6个月内无任何账户交易的电子账户以及存款余额和应计、未计利息数均为零的电子账户，无需进行事先通知，浦发银行有权限制该账户的非柜面交易或采取其它限制措施且不承担任何责任。客户如需正常使用该账户，应通过浦发银行网点或手机银行等重新验证核实开户人身份后启用。
        </p>
        <p class="distance">
          五、使用
        </p>
        <p class="distance_50" style=" font-weight: bold; font-size: 12px;">
          5.1
          凡使用密码、短信动态验证码或经双方约定的身份验证方式验证通过的电子账户交易，均视为客户本人所为。依据密码等电子数据办理的各项交易所产生的电子信息交易记录均为该项交易的有效凭证，客户应承担所有相关的还款义务。
        </p>
        <p class="distance_50" style=" font-weight: bold; font-size: 12px;">
          5.2
          客户应确保交易密码、手机号码及客户信息等资料不被泄露于任何第三方，并且应采取预防措施以防止任何有关电子账户密码、短信动态验证码等的欺诈、遗失、被抢或被盗等，否则由此产生的一切损失和后果由客户承担。
        </p>
        <p class="distance_50">
          5.3
          电子账户只限客户本人使用，不得转让、出租、转借、出售等，如客户姓名、职业、身份证件有效期、手机号码、通讯地址等重大客户信息变更，客户应及时通知浦发银行或通过相关我行电子渠道进行信息的变更操作，否则由此产生的一切后果由客户承担。客户不得使用电子账户参与洗钱、恐怖融资或扩散（大规模杀伤性武器）融资等活动，否则浦发银行有权对本协议项下的客户的电子账户采取中止服务、主动锁定和/或销户等措施，并有权终止本协议且不承担任何责任。
        </p>
        <p class="distance_50">
          上述洗钱、恐怖融资或扩散（大规模杀伤性武器）融资等活动，是指联合国安理会、反洗钱金融行动特别工作组、中国、美国、欧盟等国际组织或国家认定的洗钱、恐怖融资或扩散（大规模杀伤性武器）融资行为。上述洗钱、恐怖融资或扩散（大规模杀伤性武器）融资等活动，是指联合国安理会、反洗钱金融行动特别工作组、中国、美国、欧盟等国际组织或国家认定的洗钱、恐怖融资或扩散（大规模杀伤性武器）融资行为。
        </p>
        <p class="distance_50">
          5.4
          客户在此不可撤销地授权浦发银行，如任何非客户应得款项错误存入客户账户，并经浦发银行查实的，则浦发银行有权从客户账户中扣转该笔款项。
        </p>
        <p class="distance_50">
          5.5
          为确保客户电子账户安全，如经监管机构、公安机关或行业组织等告知或浦发银行认为，电子账户信息可能发生泄露等情况，浦发银行将及时联系客户，提示客户尽快修改密码，如因无法及时联系到客户或情况紧急，浦发银行有权采取措施临时锁定客户的电子账户。客户如需继续使用，应携带本人合法有效的居民身份证到浦发银行营业网点办理解锁。
        </p>
        <p class="distance_50">
          5.6
          为防止非客户本人对电子账户的恶意使用，浦发银行对电子账户密码采用密码录入错误限次管理。交易密码连续三次输入错误则账户将被自动锁住，客户如需继续使用，须本人持有效证件至本行营业网点办理解锁，不得由他人代办，经浦发银行核实客户身份后，办理密码解锁和重置手续。
        </p>
        <p class="distance_50">
          5.7客户若遗忘电子账户查询密码或交易密码，可通过浦发银行指定的渠道申请重置，并经浦发银行核实客户身份后，进行密码重置。
        </p>
        <p class="distance_50">
          5.8浦发银行有权根据监管机构要求对电子账户（Ⅱ类）与电子账户（Ⅲ类）的开立、功能、支付限额等规则通过公告修改本协议。公告期满后，修改后的协议即为生效。在公告期内，客户可以选择是否继续使用电子账户及相关服务。若客户不愿接受公告内容的，应在公告内容正式实施前向开户机构提出销户申请或申请变更或终止相关服务，否则视为同意接受公告的各项内容。
        </p>
        <p class="distance_50">
          六、利息和收费
        </p>
        <p class="distance_50">
          6.1 电子账户下的各类存款账户按照中国人民银行规定计息。
        </p>
        <p class="distance_50">
          6.2客户须按开户机构的规定缴纳相关费用。若客户未按规定缴纳费用，开户机构有权中止提供相应服务。电子账户收费项目和收费标准如有变动，以开户机构最新公告为准。
        </p>
        <p class="distance_50">
          6.3
          本协议一经签署，即表明客户同意按浦发银行公布的收费标准支付各类应承担的费用，并且同意浦发银行采用扣收的方式从客户电子账户中收取相关费用。同时，浦发银行有权依据国家有关规定对服务内容、收费项目或标准等内容进行调整，正式对外公告一定时期后执行并适用于本协议，无需另行通知客户。客户有权在浦发银行公告期间选择是否继续使用浦发银行电子账户及相关服务，客户不愿接受浦发银行公告内容的，应在浦发银行公告内容正式实施前向浦发银行申请变更或终止相关服务，否则视为接受公告的各项内容。
        </p>
        <p class="distance_50">
          七、电子账户的注销
        </p>
        <p class="distance_50">
          7.1 客户的终止权
        </p>
        <p class="distance_50">
          如果同时满足下列条件，客户可以终止其名下的电子账户：
        </p>
        <p class="distance_50">
          (a)已通过浦发银行网点柜面向浦发银行书面申请终止且浦发银行已收到；
        </p>
        <p class="distance_50">
          (b)符合浦发银行允许终止的其他条件。
        </p>
        <p class="distance_50">
          7.2 浦发银行的终止权
        </p>
        <p class="distance_50">
          浦发银行有权根据相关法律法规规章规定、监管部门要求、《章程》规定以及本协议约定终止客户使用电子账户。
        </p>
        <p class="distance_50">
          7.3服务终止后，客户在终止前已发送的指令仍有效，客户应承担其后果。同时浦发银行不退还已收取的相关费用。
        </p>
        <p class="distance_50">
          八、信息披露和通知
        </p>
        <p class="distance_50" style=" font-weight: bold; font-size: 12px;">
          8.1开户机构应对客户的申请资料进行保密。但开户机构在进行催收和追索欠款等工作以及维护其合法权益时，或在法律法规及规章明确规定或经客户授权同意的情况下，可将客户的有关资料提供给相关单位和人员。
        </p>
        <p class="distance_50">
          8.2
          客户同意其签署本协议即构成客户对上述任何披露或任何其它法律所规定的披露的许可。
        </p>
        <p class="distance_50">
          8.3
          客户提供的通讯地址、住址、手机号码等重大信息如有变化，应及时通知浦发银行，如客户未及时通知浦发银行，在上述资料或信息发生变化之后至浦发银行收到客户的通知前产生的损失与法律责任由客户承担。
        </p>
        <p class="distance_50">
          8.4
          客户应当及时向浦发银行提供浦发银行根据法律法规监管机构要求等可能不时要求的，与客户办理本业务相关的信息和文件。
        </p>
        <p class="distance_50">
          九、其他
        </p>
        <p class="distance_50">
          9.1
          为获得商品或服务，客户使用电子账户进行交易的，浦发银行对任何商家提供给客户的货品、服务及其质量或性能不承担任何责任。客户不得以退还使用电子账户交易取得的货物等方式向浦发银行索取退款；客户对浦发银行的义务将不会因为客户与该商家之间的任何争议而受到影响。
        </p>
        <p class="distance_50">
          9.2
          如因不可抗力或非浦发银行过错引起的系统故障、供电故障、通讯故障或网络故障等原因导致电子账户不能正常使用的，浦发银行将视情况协助客户解决或提供必要的帮助，但不承担任何经济、法律责任。对于在交易过程中，因暂时的网络通讯故障或其他原因造成的错账现象，浦发银行有权根据实际交易情况进行账务处理。
        </p>
        <p class="distance_50">
          9.3
          客户使用浦发银行提供的电子账户服务导致浦发银行所发生的全部损失及费用（包括全额补偿基础上的诉讼费、律师费等法律费用），客户应全额补偿浦发银行并使浦发银行不受其损害。
        </p>
        <p class="distance_50">
          9.4客户通过本协议约定开立账户所办理的业务，因涉嫌参与本协议5.3条约定的洗钱、恐怖融资或扩散（大规模杀伤性武器）融资等活动，导致浦发银行因履行本协议约定的义务向客户提供服务时遭受损失的，客户应赔偿浦发银行由此遭致的所有损失。上述损失包括但不限于浦发银行由于客户的活动被境内外司法机关裁判承担的损失，境内外政府机构或监管机关对于浦发银行为客户的活动提供服务所进行的处罚以及浦发银行为应对上述情形采取措施所产生的一切费用和损失等。
        </p>
        <p class="distance_50">
          办理跨境资金/价值转移业务中，境外清算代理行因反洗钱和反恐怖融资需要要求提供额外的客户身份信息、交易背景信息的，客户同意并授权浦发银行予以提供。
        </p>
        <p class="distance_50">
          9.5
          浦发银行有权根据国家法律、规定及浦发银行经营需要对本协议进行修改，应通过营业网点或网站等将修改后的协议进行公告。公告期满后，修改后的协议即为生效。在公告期内，客户可以选择是否继续使用电子账户及相关服务。若客户不愿接受公告内容的，应在公告内容正式实施前向开户机构提出销户申请或申请变更或终止相关服务，否则视为同意接受公告的各项内容。
        </p>
        <p class="distance_50">
          9.6
          本协议自客户通过浦发银行电子渠道或第三方合作渠道点击“我已阅读并同意接受《上海浦东发展银行个人电子账户产品服务协议》”即视为签署本协议并生效。
        </p>
        <p class="distance_50">
          9.7本协议适用中华人民共和国法律（为本协议目的，不包括香港、澳门特别行政区以及台湾地区的法律）。任何有关本协议的争议，均由浦发银行所在地的人民法院管辖，双方另有约定的除外。
        </p>
        <p class="distance_50">
          9.8本协议未尽事宜按照法律法规及监管机关的有关规定执行。本协议附件是本协议不可分割的组成部分，与本协议正文具有同等的法律效力。
        </p>
        <p class="distance_50" style=" font-weight: bold; font-size: 12px;">
          客户在此确认，已阅读并知晓本协议中的全部条款，且均无疑义，并对有关权利义务和责任限制或免除条款的法律含义有准确无误的理解。
        </p>
        <br />
        <p class="distance_50">附件1</p>
        <br />
        <p
          class="distance_50"
          style="font-weight: bold; font-size: 16px;text-align:center"
        >
          上海浦东发展银行个人客户隐私政策
        </p>
        <p class="distance_50" style="font-size: 12px;text-align:center">
          本版发布日期：2020年6月22日
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          上海浦东发展银行一直重视并采取措施保护用户（以下简称“您”）的个人信息。我行将根据本《上海浦东发展银行个人客户隐私政策》（以下简称“本政策”）以及其他相关法律文本中的有关约定在中华人民共和国境内（不包括香港、澳门特别行政区及台湾地区）收集、使用、储存及共享、转让、公开披露您的个人信息。此外，我行将通过本政策，说明您如何访问、更正或更新、删除、管理您的个人信息以及行使您的相关权利。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          我行强烈建议您在使用我行的服务前，仔细阅读并完全理解本政策中的全部内容，并自主进行适当的选择。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          本政策适用于浦发银行提供的所有个人客户银行服务，如我行在具体产品或服务中与您就隐私保护政策另有具体约定的，相关约定与本政策将共同构成我行与您之间的隐私政策约定，二者如有不一致之处的，以具体产品或服务中的约定为准。
        </p>
        <p class="distance_50">
          本政策将向您介绍以下内容：
        </p>
        <p class="distance_50">
          1．我行如何收集和使用您的个人信息
        </p>
        <p class="distance_50">
          2．我行如何使用 Cookie和同类技术
        </p>
        <p class="distance_50">
          3．我行如何共享、转让和公开披露您的个人信息
        </p>
        <p class="distance_50">
          4．我行如何存储和保护您的个人信息
        </p>
        <p class="distance_50">
          5．您如何管理您的个人信息
        </p>
        <p class="distance_50">
          6．我行如何处理未成年人的信息
        </p>
        <p class="distance_50">
          7．本政策如何更新
        </p>
        <p class="distance_50">
          8．如何联系我行
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          一、我行如何收集和使用您的个人信息
        </p>
        <p class="distance_50">
          个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。
        </p>
        <p class="distance_50">
          个人信息包括姓名、出生日期、身份证件号码、个人生物识别信息、通信通讯联系方式、住址、账户信息、交易信息、财产信息、信用信息、消费偏好、行踪轨迹、联网核查信息等。
        </p>

        <p class="distance_50" style="color:#000;font-weight:bold">
          （一）我行收集个人信息的原则
        </p>
        <p class="distance_50">
          我行收集您的个人信息遵循合法、正当、必要的原则。我行按照法律法规要求以及业务需要收集您的个人信息，不会收集与业务无关的信息或采取不正当方式收集信息。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （二）我行收集您的个人信息的目的
        </p>
        <p class="distance_50">
          我行收集您的个人信息，目的在于依法合规地为您提供优质的产品（或服务），该等信息对于充分履行您和我行之间的合约很有必要，并使得我行能够遵守相关法律，具体包括：
        </p>
        <p class="distance_50">
          1.为保护您的账户安全，对您的身份进行识别、验证等；
        </p>
        <p class="distance_50">
          2.为评估您的履约能力及状况，用于业务准入和风险防控；
        </p>

        <p class="distance_50">
          3.为您提供产品（或服务）所必须（包括但不限于为购买理财类产品进行的风险承受能力评估问卷、为评估您的风险偏好，合理提供产品推介和投资建议等）；
        </p>
        <p class="distance_50">
          4.为保护您的资金安全；
        </p>
        <p class="distance_50">
          5.为改善产品（或服务）、提升您的体验；
        </p>
        <p class="distance_50">
          6.为履行法定义务（如反洗钱义务等）；
        </p>
        <p class="distance_50">
          7.经您许可的其他用途。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （三）我行收集您的个人信息的方式
        </p>
        <p class="distance_50">
          为向您提供服务并确保您的电子银行服务（网上银行服务、手机银行服务、短信服务、微信银行服务、电话银行服务、直销银行服务等）安全，在您使用电子银行服务过程中，我行会收集您在使用服务过程中主动输入或因使用服务而产生的信息：
        </p>
        <p class="distance_50">
          1.当您开通电子银行服务时，依据法律法规及监管要求，我行会收集您的
          <span style="color:#000;font-weight:bold"
            >个人基本资料、身份信息、财产信息、通信信息、生物识别信息、手机号码信息，</span
          >
          以帮助您完成电子银行注册，如果您拒绝提供这些信息，您可能无法开通电子银行或无法正常使用我行的服务。
        </p>
        <p class="distance_50">
          2.当您使用浦发银行电子银行服务时，例如在下列情形中，您需要向我行提供或授权我行收集相应服务所需的用户信息。如您拒绝提供，您将无法使用相应功能或服务。
        </p>
        <p class="distance_50">
          （1） 当您注册浦发银行手机银行时，我行会收集您的
          <span style="color:#000;font-weight:bold"
            >手机号码、头像、昵称、身份证件信息、银行卡信息，</span
          >
          并验证您的客户查询密码、以及银行卡交易密码，在需要短信验证码的环节，需要读取验证码短信内容，以协助您进行验证码填写。如您拒绝通讯信息授权，我行手机银行将不读取短信内容，我行不保存短信内容。
        </p>
        <p class="distance_50">
          （2）如您在手机银行中选择通过指纹/FACE
          ID、声纹、刷脸功能进行登录、转账、支付、身份认证，需向我行提供您的<span
            style="color:#000;font-weight:bold"
            >指纹/FACE ID、声音、人脸图像信息。</span
          >我行不会采集您的指纹/FACE ID，您的指纹/FACE
          ID仅保存在您授权采集指纹的设备上。经您授权后，我行将采集您的声纹信息、人脸信息，将加密存储于我行信息系统后台数据库中。如您不提供上述信息，我行将无法向您提供需完成指纹/FACE
          ID、声纹、人脸认证后方可使用的产品或服务。您可以通过“首页-全部-安全”或在首页搜索关键词“认证”开启或关闭此功能。
        </p>
        <p class="distance_50">
          （3）当您使用微信、支付宝授权登录功能时，我行需要您提供<span
            style="color:#000;font-weight:bold"
            >微信、支付宝账号的昵称与头像信息。</span
          >您可以通过“首页-全部-第三方账号管理”取消授权及相应账号信息绑定。
        </p>
        <p class="distance_50">
          （4）当您使用我行及时语服务时，我行会收集您的<span style="color:#000;font-weight:bold"
            >账户信息和交易信息，手机号/邮箱地址/微信昵称/支付宝昵称，</span
          >以便及时向您发送账户资金变动及相关交易通知；我行也可能向我行的合作伙伴收集其合法留存并经您授权可以共享使用的信息，以便为您提供相应消息通知等服务。
        </p>
        <p class="distance_50">
          （5） 当您使用网点服务等基于地理位置的功能时，我行会收集您的<span
            style="color:#000;font-weight:bold"
            >位置信息，</span
          >目的是为了向您提供所在位置的相应服务。如您拒绝提供该信息，您将无法使用上述功能，但这不影响您正常使用手机银行的其他功能。
        </p>
        <p class="distance_50">
          （6）当您使用手机号转账等涉及通讯录的功能时，<span style="color:#000;font-weight:bold"
            >我行仅获取您从通讯录中点选的联系人信息，</span
          >并进行加密传输以防止恶意截取。上述信息属于个人敏感信息。如您不需使用上述功能，可以不提供该信息，不影响您正常使用其他功能。
        </p>
        <p class="distance_50">
          （7）当您使用转账汇款、小浦支付、扫码支付等收付款功能时，您需要提供<span
            style="color:#000;font-weight:bold"
            >收款方的姓名、银行卡号/账户等信息，并可能需要提供您的姓名、手机号、证件类型、证件号码等信息，</span
          >以便验证身份使用上述支付功能。此外，我行还会收集您的相关收付款交易记录以便您查询。具体事项按您开通我行手机银行时同意签署的《上海浦东发展银行电子银行个人客户服务协议》执行。上述信息属于敏感信息，如您拒绝提供，将无法使用上述功能，但不影响您使用手机银行其他功能。
        </p>
        <p class="distance_50">
          （8）当您使用搜索服务时，我行会收集您的<span style="color:#000;font-weight:bold"
            >搜索关键词信息。</span
          >当搜索关键词信息无法单独识别您的个人身份时，该信息不属于您的用户信息，我行可以对其加以其他目的使用；当搜索关键词信息与您的其他信息结合可以识别您的个人身份时，我行将在结合期间将您的搜索关键词信息作为您的用户信息，对其加以保护处理。
        </p>
        <p class="distance_50">
          （9）当您使用我行提供的实名认证服务时，我行可能需要您提供您的<span
            style="color:#000;font-weight:bold"
            >姓名、证件类型、证件号码、银行卡号、设备信息、指纹/FACE
            ID信息、刷脸认证</span
          >等信息，并可能通过验证手机号/查询密码、银行卡号/卡密码、短信验证码等方式对有关信息进行有效性核验。若您不提供上述信息，我行将无法向您提供须完成实名认证后方可使用的产品或服务。
        </p>
        <p class="distance_50">
          （10）当您使用内嵌的购物及生活服务等功能时，您需要在订单页面填写<span
            style="color:#000;font-weight:bold"
            >收货人姓名、收货地址及手机号码等信息；</span
          >您在预定电影票、出行、酒店等服务时，还可能需要根据国家法律法规及监管要求或服务提供方（包括票务销售方、酒店、旅行社及其授权的代理方、基础电信运营商、移动转售运营商等）的要求提供<span
            style="color:#000;font-weight:bold"
            >您的实名信息，</span
          >这些实名信息可能包括您的身份信息（比如身份证、军官证、护照、驾驶证等载明您身份的证件）、您本人的照片或视频、联系电话等。这些订单中将可能包含<span
            style="color:#000;font-weight:bold"
            >您的行程、酒店地址</span
          >等信息。上述所有信息构成您的订单信息，我行将使用您的<span
            style="color:#000;font-weight:bold"
            >订单信息</span
          >来进行您的身份核验、确定交易、支付结算、完成配送、为您查询订单以及提供客服咨询与售后服务；我行还会使用您的订单信息来判断您的交易是否存在异常以保护您的交易安全。
        </p>
        <p class="distance_50">
          下单后，您可以选择使用浦发卡支付或他行卡支付。当您下单并选择货到付款或在线完成支付后，商户和第三方配送公司将为您完成订单的交付。您在此同意，商户和第三方配送公司、售后服务等可以使用您的订单信息以为您提供商品或服务。
        </p>
        <p class="distance_50">
          我行的电话客服和售后功能会使用您的<span style="color:#000;font-weight:bold"
            >账号信息和订单信息。</span
          >为保证您的账号安全，我行的呼叫中心客服和在线客服会使用您的账号信息与您核验身份。当您需要我行提供与您订单信息相关的客服与售后服务时，我行将会查询您的<span
            style="color:#000;font-weight:bold"
            >订单信息。</span
          >您有可能会在与我行的客服人员沟通时，提供除上述信息外的其他信息，例如：当您要求我行变更配送地址、联系人或联系电话时。
        </p>
        <p class="distance_50">
          3.当您使用电子银行服务时，为了维护服务的正常运行，优化我行的服务体验及保障您的账号安全，我行会收集以下基础信息，包括您的<span
            style="color:#000;font-weight:bold"
            >设备型号、操作系统、唯一设备标识符、手机银行软件版本号、登录IP地址、接入网络的方式、类型和状态、网络质量数据、设备加速器（如重力感应设备）、操作日志、服务日志信息（如您在手机银行搜索、查看的信息、服务故障信息等），</span
          >这些信息是为您提供服务必须收集的基础信息，以保障您正常使用我行的服务。
        </p>
        <p class="distance_50">
          在特定使用场景下，我行会使用具有相应业务资质及服务能力的第三方服务商提供的软件开发工具包（简称“SDK”）来为您提供服务，<span
            style="color:#000;font-weight:bold"
            >此时需要通过SDK来收集您的必要信息，</span
          >对应使用场景详见附件。
        </p>
        <p class="distance_50">
          4.为向您提供更加准确、个性和便捷的服务，提升服务体验、改进服务质量，或为防范风险，我行会收集您<span
            style="color:#000;font-weight:bold"
            >反馈意见建议或举报时提供的信息，</span
          >收集您参与问卷调查时向我行反馈的信息，收集您使用电子银行功能或服务的类别、方式和操作信息，及您在我行的用户信息，我行会对这些信息进行统计、分析，并会根据上述信息向您提供相应服务或产品。
        </p>
        <p class="distance_50">
          5.当您在电子银行中使用第三方提供的服务时，第三方可能会获取<span
            style="color:#000;font-weight:bold"
            >您的昵称、头像、位置、姓名、证件类型、证件号码、手机号码信息；</span
          >在经过您的明示同意后，第三方可获取您的以上信息；对于您在使用第三方提供的服务时主动提供给第三方的相关信息，我行将视为您允许该第三方获取上述此类信息；对于您在使用该第三方服务时产生的信息，应由您与该第三方依法约定上述信息的收集和使用事项。如您拒绝第三方在提供服务时收集、使用或者传递上述信息，将可能会导致您无法在电子银行中使用第三方的相应服务，但这不影响您使用电子银行的其他功能。
        </p>
        <p class="distance_50">
          6.以下情形中，您可选择是否授权我行收集、使用您的个人信息：
        </p>
        <p class="distance_50">
          （1）设备状态，用于确定设备识别码，以保证账户登录的安全性。拒绝授权后，将无法正常使用浦发银行手机银行App。
        </p>
        <p class="distance_50">
          （2）存储权限，用于缓存您在使用APP过程中产生的文本、图像、视频等内容。拒绝授权后，将无法正常使用浦发银行手机银行App。
        </p>
        <p class="distance_50">
          （3）摄像头，用于如识别二维码、人脸识别、设置头像、拍摄证件信息用途，在人脸识别登录/转账/支付/认证、扫一扫、AR扫、头像设置、证件信息上传开通场景中使用。拒绝授权后，上述功能将无法使用。我行将获取的人脸等数据，加密后存储于系统后台数据库中。
        </p>
        <p class="distance_50">
          （4）相册，访问相册主要用于上传开户证件、设置您的头像、备注交易信息，保存电子回单等。我行获得的图片信息，加密后存储于数据库中。拒绝授权后，上述功能将无法使用。
        </p>
        <p class="distance_50">
          （5）麦克风，用于U-Key、声纹识别、录音、语音银行等用途，且仅在客户使用U-Key认证、声纹登录/转账/支付、语音银行场景中运用该权限。拒绝授权后，上述功能将无法使用。我行采集的声纹数据及录音数据，加密后存储于系统后台数据库中。
        </p>
        <p class="distance_50">
          （6）手机通讯录，在转账、支付，或参与个人活动过程中，用于协助您通过通讯录快速选取电话号码，无需您手动输入。拒绝授权后，向手机号转账、短信通知功能仍可以使用，但需要手工输入手机号码。手机银行仅读取并记录指定电话号码，不读取客户全量通讯录，我行后台系统不存储通讯录。
        </p>
        <p class="distance_50">
          （7）手机短信，在需要短信验证码的环节需要读取验证码短信内容协助您进行验证码填写。如您拒绝通讯信息（短信）授权，我行手机银行将不读取短信内容，系统后台不保存短信内容。
        </p>
        <p class="distance_50">
          （8）地理位置，获取您所在地理位置，主要用于电子银行交易风控、网点预约、ATM位置查询等服务。系统后台保存您交易时的位置信息。拒绝授权后，手机银行相关功能无法使用。
        </p>
        <p class="distance_50">
          （9）电话权限，用于使用手机银行时，拨打电话联系客服、线下网点等用途，且仅在客户使用场景中运用该权限。拒绝授权后，手机银行相关功能无法使用。
        </p>
        <p class="distance_50">
          （10）SIRI，用于通过SIRI办理登录、查询等用途，且仅在客户使用场景中运用该权限。拒绝授权后，手机银行相关功能无法使用。
        </p>
        <p class="distance_50">
          （11）蓝牙，用于U-Key验证等用途，且仅在客户使用场景中运用该权限。拒绝授权后，手机银行相关功能无法使用。
        </p>
        <p class="distance_50">
          （12）网络通讯，用于与服务端进行通讯。拒绝授权后，手机银行所有功能无法使用。系统后台保存客户交易时所使用设备的网络信息，包括IP、端口等信息。
        </p>
        <p class="distance_50">
          上述功能可能需要您在您的设备中向我行开启您的相机（摄像头）、地理位置（位置信息）、麦克风等访问权限，以实现这些功能所涉及的信息的收集和使用。请您注意，您开启这些权限即代表您授权我行可以收集和使用这些信息来实现上述功能，如您取消了这些授权，则我行将不再继续收集和使用您的这些信息，也无法为您提供上述与这些授权所对应的功能。
        </p>
        <p class="distance_50">
          如在上述情形之外收集或使用您的信息，我行会事先征求您的同意，并向您充分告知信息收集和使用的目的、方式和范围。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （四）我行如何使用您的个人信息
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          1.在我行向您提供金融产品或服务，以及改进这些产品或服务时使用。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          2.在我行向您提供金融服务期间，您授权我行持续收集和使用您的相关个人信息。在您注销服务或取消授权时，我行将停止收集及使用您的相关个人信息，但我行会根据法律法规及监管的要求在业务资料归档、审计、监管协查等领域继续使用此前收集的您的相关个人信息。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          3.为提升您的体验，或为防范风险，我行会对您服务使用情况的相关信息进行统计分析、加工，但这些信息不会包含您的任何身份识别信息。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          4.因反洗钱和反恐怖融资需要，授权我行向且仅向涉及办理被调查业务的第三方金融机构提供您在我行的相关资料。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          5.将您的个人信息用于法律允许的其它用途。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          6.当我行要将您的用户信息，用于本政策载明的收集目的、用途或合理相关范围以外的其他用途时，我行将在使用前再次征得您的同意
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          7.根据相关法律法规、监管要求及国家标准，以下情形中，我行可能会收集、使用您的相关个人信息而无需另行征求您的授权同意：
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （1）与国家安全、国防安全直接相关的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （2）与公共安全、公共卫生、重大公共利益直接相关的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （3）与犯罪侦查、起诉、审判和判决执行等直接相关的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （5）所收集的个人信息是您自行向社会公众公开的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （7）根据您要求签订和履行合同所必需的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （8）用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （9）出于公共利益开展统计或学术研究所必需，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （10）法律法规及监管要求规定的其他情形。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          二、我行如何使用Cookie和同类技术
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （一）Cookie
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          为确保网站正常运转，我行会在您的计算机或移动设备上存储名为Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。借助于Cookie，网站能够存储您的偏好或者您使用的商品或服务等数据。我行不会将Cookie用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除
          Cookie。有关详情，请参见
          AboutCookies.org。您可以清除计算机上保存的所有
          Cookie，大部分网络浏览器都设有阻止 Cookie
          的功能。但如果您这么做，则需要在每一次访问我行的网站时亲自更改用户设置。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （二）网站信标和像素标签
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          除 Cookie
          外，我行还会在网站上使用网站信标和像素标签等其他同类技术。例如，我行向您发送的电子邮件可能含有链接至我行网站内容的点击
          URL。如果您点击该链接，我行则会跟踪此次点击，帮助我行了解您的产品或服务偏好并改善客户服务。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我行能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时退订。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （三）Do Not Track（请勿追踪）
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          很多网络浏览器均设有 Do Not Track 功能，该功能可向网站发布 Do Not
          Track
          请求。目前，主要互联网标准组织尚未设立相关政策来规定网站应如何应对此类请求。但如果您的浏览器启用了
          Do Not Track，那么我行的所有网站都会尊重您的选择。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （四）日志与位置信息
        </p>
        <p class="distance_50">
          为提升您的体验及保护您的资金安全之目的，我行可能会自动收集日志信息和位置信息。我行不会将这些信息用于本政策撰述目的之外的任何用途。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          日志信息包括：
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          1.设备或软件信息，例如您的移动设备、网页浏览器或您用于接收我行服务的其他程序所提供的配置信息、IP地址、无线网络接入信息，以及您的移动设备所用的版本和设备识别码；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          2.您在设备上曾使用的移动应用（APP）和其他软件的信息。位置信息指您开启设备定位功能并使用我行基于位置提供的相关服务时，我行收集的有关您位置的信息。您可以通过关闭定位功能随时停止我行对您的地理位置信息的收集。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          三、我行如何共享、转让和公开披露您的个人信息
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （一）共享
        </p>
        <p class="distance_50">
          除以下情况外，我行不会主动与其他任何公司、组织和个人分享您的个人信息：
        </p>
        <p class="distance_50">
          1.政府、监管部门或司法机关要求共享等法律法规规定的情况下，我行将向其共享您的个人信息；
        </p>
        <p class="distance_50">
          2.事先获得您的明确同意。如因业务需要对外共享您的个人信息时，我们会向您告知共享个人信息的目的、范围和数据接收方身份，并征得您的授权或同意。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （二）转让
        </p>
        <p class="distance_50">
          我行不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
        </p>
        <p class="distance_50">
          1．在获取明确同意的情况下转让：获得您的明确同意或授权后，我行会向其他方转让您的个人信息；
        </p>

        <p class="distance_50">
          2．根据法律法规规定或强制性的行政与司法要求；
        </p>
        <p class="distance_50">
          3．根据法律法规和商业惯例，在合并、收购、资产转让、兼并、重组或破产清算等类似交易中，如涉及到个人信息转让，我行会要求新的持有您个人信息的公司、组织继续受本徇私政策的约束，否则我行将要求该公司、组织重新向您征求授权同意。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （三）公开披露
        </p>
        <p class="distance_50">我行仅会在以下情况下，公开披露您的个人信息：</p>
        <p class="distance_50">1．获得您明确同意或授权后；</p>
        <p class="distance_50">
          2．政府、监管部门或司法机关要求披露等法律法规规定的情况下，我行将公开披露您的个人信息，且无需征得您的同意。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （四）征得授权同意的例外
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          根据相关法律法规及监管要求、国家标准，以下情形中，我行可能会共享、转让、公开披露用户信息无需事先征得您授权同意：
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （1）与履行国家法律法规及行业主管部门有关规定的义务相关的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （2）与国家安全、国防安全直接相关的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （3）与公共安全、公共卫生、重大公共利益直接相关的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （4）与犯罪侦查、起诉、审批和判决执行等直接相关的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （5）出于维护您或其他个人的生命、财产、声誉等重大合法权益但又很难得到本人同意的；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （6）您自行向社会公众公开的个人信息；
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （7）从合法公开披露的信息中收集的用户信息，如合法的新闻报道、政府信息公开等渠道。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （8）用于维护所提供的金融产品或服务的安全稳定运行所必需的，例如识别、处置金融产品或服务中的欺诈或被盗用等。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          四、我行如何存储和保护您的个人信息
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （一）存储
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          按照相关法律法规规定，我行将中华人民共和国境内（不包括香港、澳门特别行政区及台湾地区）提供服务过程中收集和产生的您的个人信息存储在中华人民共和国境内（不包括香港、澳门特别行政区及台湾地区）。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          我行仅在为您提供服务及相关服务之目的所必需的期限内和法律法规及监管规定的时限内留存您的个人信息。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          如果终止服务，我行将及时停止收集您个人信息，并对所持有的您的个人信息进行删除或匿名化处理，法律法规或监管机构对个人信息存储时间另有规定的除外。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （二）保护
        </p>
        <p class="distance_50">
          1.我行已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权的访问、公开披露、使用、修改、损坏或丢失。我行会采取一切合理可行的措施，保护您的个人信息。例如：我行会使用加密技术确保数据的保密性；我行会使用受信赖的保护机制防止数据遭到恶意攻击；我行会部署访问控制机制，确保只有授权人员才可访问个人信息；以及我行会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
        </p>
        <p class="distance_50">
          2.我们会采取一切合理可行的措施，确保不收集无关的个人信息。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          3.请您理解，由于技术水平局限以及可能存在的恶意攻击，有可能出现我行无法合理预见、防范、避免、控制的意外情况。互联网并非绝对安全的环境，请使用复杂密码，协助我行保证您的账号安全。
        </p>
        <p class="distance_50">
          4.如发生个人信息安全事件，我行将按照法律法规要求，及时将事件相关情况以邮件或信函或电话或推送通知等方式告知您，或采取合理、有效的方式发布公告。同时，我行还将依据监管规定，主动上报个人信息安全事件处置情况。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          五、您如何管理您的个人信息
        </p>
        <p class="distance_50">
          按照中国相关的法规和监管规定，我行保障您对自己的个人信息行使以下权利：
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （一）访问、更正及更新您的个人信息
        </p>
        <p class="distance_50">
          您有权通过我行网上银行、手机银行、微信银行、电话银行等渠道的个人信息修改功能服务访问及更正、更新您的个人信息，法律法规规定的例外情况除外。您有责任及时更新您的个人信息。在您修改个人信息之前，我行会验证您的身份。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （二）删除您的个人信息
        </p>
        <p class="distance_50">
          在以下情形中，您可以向我行提出删除个人信息的请求：
        </p>
        <p class="distance_50">1．如果我行处理您个人信息的行为违反法律法规；</p>
        <p class="distance_50">
          2．如果我行收集、使用您的个人信息，却未征得您的同意；
        </p>
        <p class="distance_50">
          3．如果我行处理个人信息的行为违反了与您的约定；请您注意，我行电子银行签约用户仅在手机设备中删除手机银行App时，我行不会解除您的电子银行签约，有关您手机银行的一切信息不会删除。
        </p>
        <p class="distance_50">
          4．如果您终止我行提供的账户服务和电子银行服务；
        </p>
        <p class="distance_50">5．如果我行不再为您提供服务。</p>
        <p class="distance_50">
          如我们决定响应您的删除请求，我们还将同时通知从我行获得您个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。
        </p>
        <p class="distance_50">
          当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （三）注销用户
        </p>
        <p class="distance_50">
          如您为我行手机银行用户，您可通过营业网点、手机银行等渠道注销您的手机银行签约账户。您注销手机银行的行为是不可逆行为，一旦注销，我行将不再通过手机银行收集您的个人信息，并将删除有关您手机银行的信息，法律法规或监管机构对个人信息存储时间另有规定的除外。您可以自主选择卸载或停止使用浦发银行手机银行客户端，以阻止我行获取您的个人信息。请您注意，我行手机银行签约绑定客户仅在手机设备中删除手机银行客户端时，我行不会注销您的手机银行账户，有关您手机银行账户的一切信息不会删除。您仍需要注销您的手机银行签约账户方能达到以上目的。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （四）改变您的授权范围
        </p>
        <p class="distance_50">
          您有权决定是否继续对您个人信息采集、使用等进行授权，您可以通过浦发银行手机银行首页搜索“安全”，进入安全页面，关闭本隐私政策的授权，关闭后我行将不再继续采集、使用、您相应的个人信息，请您理解如您取消授权，我行将无法为您提供电子渠道服务（含浦发手机银行、网上银行）服务，也不再继续处理您相应的个人信息（如您已就具体产品或服务与我行另行签署授权的除外），但您取消本隐私政策授权的决定，不会影响我行此前基于您授权已开展的个人信息处理。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （五）获取您的个人信息副本
        </p>
        <p class="distance_50">
          您有权获取您的个人信息副本。如果您需要获取我行收集的您的个人信息副本，您可通过联系附近的浦发营业网点，在符合相关法律法规且技术可行的前提下，我行将根据您的要求向您提供您的个人信息副本。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          （六）响应您的上述请求
        </p>
        <p class="distance_50">
          为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我行可能会先要求您验证自己的身份，然后再处理您的请求。请您理解，对于某些无端重复、需要过多技术手段、给他人合法权益带来风险或者非常不切实际的请求，我行可能会予以拒绝。
        </p>
        <p class="distance_50">
          在以下情形中，按照法律法规要求，我行将无法响应您的请求：
        </p>
        <p class="distance_50">1.与国家安全、国防安全直接相关的；</p>
        <p class="distance_50">
          2.与公共安全、公共卫生、重大公共利益直接相关的；
        </p>
        <p class="distance_50">
          3.与犯罪侦查、起诉、审判和判决执行等直接相关的；
        </p>
        <p class="distance_50">4.有充分证据表明您存在主观恶意或滥用权利的；</p>
        <p class="distance_50">
          5.响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的。
        </p>
        <p class="distance_50">6.涉及商业秘密的。</p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          六、我行如何处理未成年人的信息
        </p>

        <p class="distance_50" style="color:#000;font-weight:bold">
          我行的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，未成年人不得创建自己的用户账户。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          对于经父母同意而收集未成年个人信息的情况，我行只会在法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          七、本政策如何更新
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          根据国家法律法规变化及服务运营需要，我行可能会对本政策及相关规则进行修改，修改后的内容会通过我行网上银行、手机银行等渠道予以公告，并取代此前相关内容。在公告期内，您可以选择是否继续同意授权，若您不愿接受公告内容，应在公告内容正式实施前取消授权。如您继续使用我行服务，即表示您已充分阅读、理解并接受更新后的政策并愿意接受更新后的政策约束。未经您的明确同意，我行不会削减您按照本隐私政策所应享有的权利。您应不时关注相关公告、提示信息及协议、规则等相关内容的变动。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          八、如何联系我行
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          如您对本隐私政策有任何疑问、意见或建议，请联系我行客服热线：95528。受理您的问题后，我行会及时处理，将在15个工作日内给予答复。
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          公司名称：上海浦东发展银行股份有限公司
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          注册地址：上海市中山东一路12号
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          邮箱地址： dcsc02@spdb.com.cn
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          请您在同意之前仔细阅读本隐私政策，确保对其内容含义及相应法律后果已全部知晓并充分理解。您选择“同意”即视为您接受并签署本隐私政策授权，我行将按照相关法律法规及本政策合法使用和保护您的个人信息。
        </p>

        <p class="distance_50">附件：</p>
        <p style=" font-weight: bold; font-size: 16px;text-align:center">
          浦发银行SDK使用场景列表
        </p>
        <p class="distance_50">
          当您使用浦发银行App的功能或服务时，在特定使用场景下，App会使用具有相应业务资质及服务能力的第三方服务商提供的应用软件开发工具包（简称“SDK”）来为您提供服务，此时需要通过SDK来收集您的必要信息。以下表格包含了您在使用APP的过程中可能触及到的SDK产品，供您查询了解。
        </p>
        <p class="distance_50">
          我们将尽全力保护您的个人信息和合法权益，再次感谢您的信任！
        </p>
        <table border="1" style="border-collapse: collapse;" class="table">
          <thead>
            <tr>
              <th>SDK名称</th>
              <th>采集数据</th>
              <th>提供服务/功能</th>
              <th>所属公司</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                个推SDK（包括小米推送SDK、华为推送SDK、OPPO推送SDK、VIVO推送SDK、魅族推送SDK）
              </td>
              <td>
                手机终端标识信息、手机厂商、手机型号、系统类型、系统版本、电话状态信息
              </td>
              <td>App消息推送功能，推送服务及账户变动通知</td>
              <td>浙江每日互动网络科技有限公司</td>
            </tr>
            <tr>
              <td>依图SDK</td>
              <td>手机终端标识信息，获取摄像头、麦克风权限</td>
              <td>人脸识别、活体检测</td>
              <td>上海依图网络科技有限公司</td>
            </tr>
            <tr>
              <td>飞天Ukey SDK</td>
              <td>手机电话状态信息，麦克风权限</td>
              <td>Ukey安全认证功能</td>
              <td>飞天诚信科技股份有限公司</td>
            </tr>
            <tr>
              <td>天地融Ukey SDK</td>
              <td>手机电话状态信息，麦克风权限</td>
              <td>Ukey安全认证功能</td>
              <td>天地融科技股份有限公司</td>
            </tr>
            <tr>
              <td>银联HCE SDK</td>
              <td>手机终端标识信息</td>
              <td>银联HCE、无卡支付功能</td>
              <td>中国银联</td>
            </tr>
            <tr>
              <td>腾讯设备指纹SDK</td>
              <td>手机终端标识信息、位置信息、电话状态信息</td>
              <td>网络贷款申请过程中的反欺诈识别功能</td>
              <td>腾讯公司</td>
            </tr>
            <tr>
              <td>大智慧SDK</td>
              <td>手机终端标识信息、电话状态信息、麦克风权限</td>
              <td>提供贵金属、商品、外汇行情服务</td>
              <td>大智慧</td>
            </tr>
            <tr>
              <td>中国金融认证中心（CFCA）SDK</td>
              <td>
                获取客户数据： 姓名、证件类型、证件号码、电话号码 设备类数据：
                手机终端标识信息、手机厂商、手机型号、系统类型、系统版本、网络类型、IP、MAC地址、电话状态；
              </td>
              <td>
                向CFCA申请专属于用户本人的数字证书，保障手机银行交易安全。
              </td>
              <td>中国金融认证中心（CFCA）</td>
            </tr>
            <tr>
              <td>科大讯飞语音SDK</td>
              <td>
                麦克风权限
              </td>
              <td>
                语音银行中的语音识别功能
              </td>
              <td>科大讯飞股份有限公司</td>
            </tr>
            <tr>
              <td>合合信息OCR SDK</td>
              <td>
                摄像头权限
              </td>
              <td>
                卡号、身份证件识别服务中的拍照、图像识别功能
              </td>
              <td>上海合合信息技术发展有限公司</td>
            </tr>
            <tr>
              <td>视+AR SDK</td>
              <td>
                摄像头权限
              </td>
              <td>
                AR识别
              </td>
              <td>视辰信息科技（上海）有限公司</td>
            </tr>
            <tr>
              <td>极验SDK</td>
              <td>
                手机终端标识信息、手机厂商、手机型号、设备名称、系统语言、系统类型、系统版本、网络类型、IP地址
              </td>
              <td>
                验证码校验
              </td>
              <td>武汉极意网络科技有限公司</td>
            </tr>
            <tr>
              <td>电子社保SDK</td>
              <td>
                获取客户数据：姓名、证件类型、证件号码、电话号码、实体社保卡号（二级）
                设备类数据：IOS:UUID、手机型号、系统版本；安卓：安卓ID、手机型号、系统版本
              </td>
              <td>
                访问全国社保卡平台
              </td>
              <td>金保信社保卡科技有限公司</td>
            </tr>
            <tr>
              <td>微通SDK</td>
              <td>
                无
              </td>
              <td>
                密码键盘
              </td>
              <td>北京微通新成公司</td>
            </tr>
          </tbody>
        </table>
      </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'pufaAccountAgreement',
  data() {
    return {};
  },
  props: {
    hidePopup: {
      type: Function,
      default: null,
    },
  },
  methods: {
    close() {
      this.hidePopup();
    },
  },
};
</script>
<style scoped>
.base_color{
  width: 100%;
  height: 100%;
}
.crossBox{
  text-align: right;
}
.cross{
  font-size: 20px;
}
#container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.clause{
  flex: 1;
  overflow: auto;
  background: #fff;
  background-size: contain;
}
* {
  /* width: 90%; */
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-size: 12px;
}
body {
  font-family: '微软雅黑';
}
.distance {
  text-align: left;

  /* margin-left: 10px; */
}
.distance_50 {
  letter-spacing: 0;
  text-align: left;
  text-indent: 24px;
}
.distance_80 {
  text-align: left;

  /* margin-left: 10px; */
}
p {
  margin-bottom: 8px;
}
#close {
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 30px;
  padding-right: 10px;
  color: white;
  font-size: 20px;
  line-height: 30px;
  text-align: right;
  background: #3d4145;
}
.table{
  margin: 20px 10px;
}
</style>
